import { gsap } from 'gsap';
import { debounce } from 'lodash';
import { Util } from './_util.js';

class ClubCarrotClass {
  constructor(id) {
    this.id = id;
    this.prevTotalQuantity = 0;
  }

  updateTotalQuantity(totalQuantity) {
    if (totalQuantity !== this.prevTotalQuantity) {
      this.prevTotalQuantity = totalQuantity;
      return true;
    }
    return false;
  }
}
const Carrot = {
  cartQuantity: '',
  listenXHR: function() {
    const origXHR = window.XMLHttpRequest;
    window.XMLHttpRequest = function() {
      const xhr = new origXHR();
      xhr.open = (method, url) => {
        origXHR.prototype.open.call(xhr, method, url);

        //   console.log('Connection just opened to:', url);

        let cartUrl = new URL(url);
        if (cartUrl.pathname.split('/')[2] == 'cart') {
          console.log('Connection just opened to:', url);
          let cartID = cartUrl.pathname.split('/')[3];
          sessionStorage.setItem('cartID', cartID);
          setTimeout(() => {
            Carrot.cartWatchC7(cartID);
          }, 1500);
        }
      };
      return xhr;
    };
  },
  lookSession: function() {
    window.addEventListener('load', (event) => {
      if (sessionStorage.getItem('cartID')) {
        let cartID = sessionStorage.getItem('cartID');
        setTimeout(() => {
          Carrot.cartWatchC7(cartID);
        }, 1500);
      }
    });
  },
  cartWatch: function() {
    let fireMainCarrot;
    let fireCartCarrot;
    let targetNode = document.querySelector('#c7-cart');

    // Options for the observer (which mutations to observe)
    let config = { attributes: true, childList: true, subtree: true };

    function updateMainCarrot() {
      let url = new URL(window.location);
      if (!url.pathname.includes('/checkout/')) {
        if (!document.body.contains(document.querySelector('#c7-cart .c7-cart__count'))) return false;
        Carrot.cartQuantity = parseInt(document.querySelector('#c7-cart .c7-cart__count').innerText);
        Carrot.updateCarrot(Carrot.cartQuantity);
      }
    }

    function updateCartCarrot() {
      if (!document.body.contains(document.querySelector('#c7-cart .c7-cart__count'))) return false;
      Carrot.cartQuantity = parseInt(document.querySelector('#c7-cart .c7-cart__count').innerText);
      Carrot.updateCartCarrot(Carrot.cartQuantity);
    }

    // Callback function to execute when mutations are observed
    function mutate(mutations) {
      //   debounce
      fireMainCarrot = debounce(updateMainCarrot, 1000, {
        leading: true,
        trailing: false,
      });

      fireMainCarrot();

      //so we don't get an infinite loop
      for (const mutation of mutations) {
        if (mutation.type === 'childList') {
          //  console.log('mutation.addedNodes', mutation.addedNodes);

          if (mutation.addedNodes.length == 0) {
            fireCartCarrot = debounce(updateCartCarrot, 1000, {
              leading: true,
              trailing: false,
            });

            fireCartCarrot();
          }

          [...mutation.addedNodes].forEach((element) => {
            //  console.log('element', element.className);

            if (
              mutation.addedNodes[0].ariaLabel != null ||
              element.className == 'c7-cart__cart-carrot c7-cart__cart-carrot-side-cart-bottom' ||
              element.className == 'undefined' ||
              element.className == 'c7-cart__loading'
            ) {
              fireCartCarrot = debounce(updateCartCarrot, 1000, {
                leading: true,
                trailing: false,
              });

              fireCartCarrot();
            }
          });
        }
      }
    }

    // Create an observer instance linked to the callback function
    let observer = new MutationObserver(mutate);

    // Start observing the target node for configured mutations
    observer.observe(targetNode, config);
  },
  cartWatchC7: function(cartID) {
    let C7tenant = window.stagingC7 ? 'staging-rombauer' : 'rombauer-vineyards';

    fetch(`https://api.commerce7.com/v1/cart/${cartID}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        tenant: C7tenant,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        //  console.log(data);

        let totalQuantity = 0;

        Object.values(data.items).forEach((val) => {
          if (val.type == 'Wine') {
            totalQuantity = totalQuantity + val.quantity;
          }

          const validTitles = ['2021 Buchli Station Chardonnay', '2021 Home Ranch Chardonnay']; //limit options to 2

          // console.log(val.productTitle);

          if (validTitles.includes(val.productTitle)) {
            Carrot.adjustLimitedQuantityCartOptions(val.productTitle);
          }

          if (val.productTitle.includes('|')) {
            Carrot.removePipeFromTitle(val.productTitle);
          }
        });

        //   console.log('totalQuantity', totalQuantity);
        return totalQuantity;
      })
      .then((totalQuantity) => {
        Carrot.updateCarrot(totalQuantity);
        Carrot.updateCartCarrot(totalQuantity);
      });
  },
  updateCarrot: function(quantity) {
    let qty = quantity;
    let carrotMain = document.querySelector('.carrot-ctr.main-ctr');
    let carrotMainMsg = document.querySelector('.carrot-ctr.main-ctr .carrot-msg');
    let carrotMainBtls = document.querySelectorAll('.carrot-ctr.main-ctr .bottle-ctr svg');

    // let carrotCartMsg = document.querySelector('.carrot-ctr.carrot-cart .carrot-msg');
    // let carrotCartBtls = document.querySelectorAll('.carrot-ctr.carrot-cart .bottle-ctr img');

    if (qty <= 0) {
      carrotMainMsg.innerText = 'Uncork 1 cent shipping with 6 bottles'; //'ONE CENT shipping on any 6+ bottles!'
    } else if (qty <= 5) {
      if (qty == 5) {
        carrotMainMsg.innerHTML = `You’re <strong>${6 - qty} bottle</strong> away from a shipping special!`;
      } else {
        carrotMainMsg.innerHTML = `You’re <strong>${6 - qty} bottles</strong> away from a shipping special!`;
      }
    } else {
      carrotMainMsg.innerText = `You’ve uncorked special shipping rates!`;
    }

    [...carrotMainBtls].forEach((element, index, array) => {
      let bottle = element;
      let fill = bottle.querySelector('.bottle-trans');

      if (index + 1 <= qty) {
        if (!bottle.classList.contains('fill')) {
          fill.classList.add('fill');
        }
      } else {
        fill.classList.remove('fill');
      }
    });
  },
  adjustLimitedQuantityCartOptions: function(val) {
    // Select the node that will be observed for mutations
    const targetNode = document.getElementById('c7-cart');

    // Options for the observer (which mutations to observe)
    const config = { childList: true, subtree: true };

    // Callback function to execute when mutations are observed
    const callback = function(mutationsList, observer) {
      for (const mutation of mutationsList) {
        if (mutation.type === 'childList') {
          if (mutation.target === targetNode || targetNode.contains(mutation.target)) {
            // Perform your desired action here
            // console.log('Element and its children have stopped mutating');

            let cartItems = document.querySelectorAll('.c7-order-items--cart .c7-order-item');

            [...cartItems].forEach((element) => {
              if (element.querySelector('.c7-order-item__title').innerHTML == val) {
                let select = element.querySelector('.c7-order-item__pricing .c7-order-item__quantity select');
                for (let i = 0; i < select.options.length; i++) {
                  const option = select.options[i];
                  // console.log(parseInt(option.value));
                  if (parseInt(option.value) > 2 || option.value == 'Other') {
                    option.disabled = true;
                    option.style.display = 'none';
                  }
                }
              }
            });
          }
        }
      }
    };

    // Create an observer instance linked to the callback function
    const observer = new MutationObserver(callback);

    // Start observing the target node for configured mutations
    observer.observe(targetNode, config);
  },
  removePipeFromTitle: function(val) {
    const targetNode = document.getElementById('c7-cart');

    function processTitle(title) {
      if (!title.includes('|')) {
        return null;
      }

      let processedTitle = title.split('|')[1].trim();
      let titlesplit = processedTitle.match(/^(\S+)\s(.*)/);

      if (titlesplit && titlesplit.length > 1) {
        return { part1: titlesplit[1], part2: titlesplit[2] };
      }

      return null;
    }

    let updateTitle = (element) => {
      // Use element directly to update its innerHTML
      let titleElement = element.querySelector('.c7-order-item__title a'); // Get the actual DOM element
      let titleText = titleElement.innerHTML; // Get the text content of the element
      let processed = processTitle(titleText); // Process the title text

      if (processed) {
        titleElement.innerHTML = `${processed.part2}`; // Update the innerHTML of the DOM element
      }
    };

    function adjustProductUpsellTitles() {
      // Function to process and update the title
      function processUpsellTitle(titleElement) {
        let titleText = titleElement.textContent; // Get the current text content of the title element

        if (titleText.includes('|')) {
          let processedTitle = titleText.split('|')[1].trim(); // Split the title at '|' and trim
          titleElement.textContent = processedTitle; // Update the text content of the title element
        }
      }

      // Select all elements with the class '.c7-carrot__product__details__title'
      let upsellTitles = document.querySelectorAll('.c7-carrot__product__details__title');

      // Iterate over each title element and process it
      upsellTitles.forEach((titleElement) => {
        processUpsellTitle(titleElement);
      });
    }

    let cartItems = document.querySelectorAll('.c7-order-items--cart .c7-order-item');
    [...cartItems].forEach((element) => {
      let itemTitle = element.querySelector('.c7-order-item__title').innerHTML;

      if (itemTitle == val) {
        updateTitle(element); // Call updateTitle function to update the title
        adjustProductUpsellTitles();
      }
    });

    const config = { childList: true, subtree: true };

    const callback = function(mutationsList, observer) {
      for (const mutation of mutationsList) {
        if (mutation.type === 'childList') {
          if (mutation.target === targetNode || targetNode.contains(mutation.target)) {
            let cartItems = document.querySelectorAll('.c7-order-items--cart .c7-order-item');
            [...cartItems].forEach((element) => {
              let itemTitle = element.querySelector('.c7-order-item__title').innerHTML;
              if (itemTitle == val) {
                updateTitle(element); // Reuse the updateTitle function here as well
                adjustProductUpsellTitles();
              }
            });
          }
        }
      }
    };

    const observer = new MutationObserver(callback);
    observer.observe(targetNode, config);
  },
  timerCart: '',
  updateCartCarrot: function(quantity) {
    //cart

    clearTimeout(Carrot.timerCart);

    let qty = quantity;

    let carrotCartMsg = document.querySelector('.carrot-ctr.carrot-cart .carrot-msg') || null;
    let carrotCartBtls = document.querySelectorAll('.carrot-ctr.carrot-cart .bottle-ctr img') || null;
    let tl = gsap.timeline({ ease: 'Power3.inOut', paused: true });

    if (qty <= 0) {
      if (document.contains(carrotCartMsg)) {
        carrotCartMsg.innerText = 'Uncork 1 cent shipping with 6 bottles';
      }
    } else if (qty <= 5) {
      if (qty == 5) {
        carrotCartMsg.innerHTML = `You’re <strong>${6 - qty} bottle</strong> away from a shipping special!`;
      } else {
        carrotCartMsg.innerHTML = `You’re <strong>${6 - qty} bottles</strong> away from a shipping special!`;
      }
    } else {
      carrotCartMsg.innerText = `You’ve uncorked special shipping rates!`;
    }

    [...carrotCartBtls].forEach((element, index, array) => {
      let bottle = element;

      if (index + 1 <= qty) {
        if (bottle.src != 'https://rombauer.s3.us-west-1.amazonaws.com/carrot-images/orange-bottle.svg') {
          bottle.src = 'https://rombauer.s3.us-west-1.amazonaws.com/carrot-images/orange-bottle.svg';
        }
      } else {
        if (bottle.src != 'https://rombauer.s3.us-west-1.amazonaws.com/carrot-images/orange-bottle-stroke.svg') {
          bottle.src = 'https://rombauer.s3.us-west-1.amazonaws.com/carrot-images/orange-bottle-stroke.svg';
        }
      }
    });

    let filledInBottles = [];

    [...carrotCartBtls].forEach((element, index, array) => {
      let bottle = element;

      if (bottle.src == 'https://rombauer.s3.us-west-1.amazonaws.com/carrot-images/orange-bottle.svg') {
        filledInBottles.push(bottle);
      }
    });

    Carrot.timerCart = window.setTimeout(() => {
      //  console.log('timer');
      tl.fromTo(filledInBottles, { duration: 0.4, yPercent: 0 }, { yPercent: -10, stagger: 0.1 }).to(filledInBottles, { duration: 0.4, yPercent: 0, stagger: 0.1 }, '=-.1');
    }, 700);

    setTimeout(() => {
      tl.play();
    }, 700);
  },
  clubReceiptCarrot: function() {
    //seen on checkout of club membership
    //http://rombauer-2021.local/profile/club-membership/receipt/f940092d-6dfe-431b-aeaa-15b3a40f3b85

    let clubCarrotMarkup = `
    <div class="carrot-ctr main-ctr club-membership">
    <p class="carrot-msg">Uncork 1 cent shipping with 6 bottles</p>
        <ul class="bottle-ctr">
              <li>
                <svg version="1.1" class="white_carrot_bottle" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 7.5 28.5" style="enable-background:new 0 0 7.5 28.5;" xml:space="preserve">
                <g id="_x35_">
                  <path class="bottle-trans" d="M5.2,7.2C5,6.9,4.9,2.2,4.9,0.7c0-0.1-0.1-0.2-0.2-0.3C4.6,0.3,4.5,0.3,4.4,0.3H3.1C3,0.3,2.8,0.3,2.8,0.4
                    C2.7,0.5,2.6,0.6,2.6,0.7c0,1.5-0.1,6.1-0.3,6.4c-0.6,1.1-2.1,1.5-2.1,4.4c0,2.9,0.1,13.3,0.1,14.4v0.9c0,0.4,0.2,0.7,0.4,1
                    c0.3,0.3,0.6,0.4,1,0.4h4c0.4,0,0.7-0.1,1-0.4c0.3-0.3,0.4-0.6,0.4-1V26c0-1,0.1-11.4,0.1-14.4C7.2,8.6,5.8,8.3,5.2,7.2z"></path>
                  <path class="bottle-stroke" d="M5.8,28.5h-4c-0.5,0-0.9-0.2-1.2-0.5c-0.3-0.3-0.5-0.7-0.5-1.1V26c0-0.4,0-2.1,0-4.2c0-3.6,0-8.3,0-10.2
                    c0-2.2,0.8-3,1.5-3.7C1.7,7.6,2,7.4,2.1,7.1c0.1-0.3,0.2-2.8,0.2-6.3c0-0.2,0.1-0.4,0.2-0.5C2.7,0.1,2.9,0,3.1,0h1.3
                    c0.2,0,0.4,0.1,0.5,0.2c0.1,0.1,0.2,0.3,0.2,0.5c0,3.6,0.1,6,0.2,6.3C5.5,7.4,5.8,7.6,6,7.9c0.7,0.7,1.5,1.5,1.5,3.7
                    c0,1.8,0,6.6,0,10.2c0,2.1,0,3.8,0,4.2v0.9c0,0.4-0.2,0.8-0.5,1.1C6.6,28.3,6.2,28.5,5.8,28.5z M3.1,0.5C3,0.5,3,0.5,2.9,0.6
                    c0,0-0.1,0.1-0.1,0.2C2.8,6.9,2.6,7.2,2.6,7.3C2.4,7.7,2.1,7.9,1.8,8.2c-0.6,0.7-1.3,1.4-1.3,3.4c0,1.8,0,6.6,0,10.2
                    c0,2.1,0,3.8,0,4.2v0.9c0,0.3,0.1,0.6,0.3,0.8C1.1,27.9,1.4,28,1.7,28h4c0.3,0,0.6-0.1,0.8-0.3c0.2-0.2,0.3-0.5,0.3-0.8V26
                    c0-0.4,0-2.1,0-4.2c0-3.6,0-8.3,0-10.2c0-2-0.7-2.7-1.3-3.4C5.4,7.9,5.1,7.7,4.9,7.3C4.9,7.2,4.7,6.9,4.6,0.7c0-0.1,0-0.1-0.1-0.2
                    c0,0-0.1-0.1-0.2-0.1H3.1z M5.4,7.1L5.4,7.1L5.4,7.1z"></path>
                </g>
                </svg>
              </li>
              <li>
              <svg version="1.1" class="white_carrot_bottle" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 7.5 28.5" style="enable-background:new 0 0 7.5 28.5;" xml:space="preserve">
              <g id="_x35_">
                <path class="bottle-trans" d="M5.2,7.2C5,6.9,4.9,2.2,4.9,0.7c0-0.1-0.1-0.2-0.2-0.3C4.6,0.3,4.5,0.3,4.4,0.3H3.1C3,0.3,2.8,0.3,2.8,0.4
                  C2.7,0.5,2.6,0.6,2.6,0.7c0,1.5-0.1,6.1-0.3,6.4c-0.6,1.1-2.1,1.5-2.1,4.4c0,2.9,0.1,13.3,0.1,14.4v0.9c0,0.4,0.2,0.7,0.4,1
                  c0.3,0.3,0.6,0.4,1,0.4h4c0.4,0,0.7-0.1,1-0.4c0.3-0.3,0.4-0.6,0.4-1V26c0-1,0.1-11.4,0.1-14.4C7.2,8.6,5.8,8.3,5.2,7.2z"></path>
                <path class="bottle-stroke" d="M5.8,28.5h-4c-0.5,0-0.9-0.2-1.2-0.5c-0.3-0.3-0.5-0.7-0.5-1.1V26c0-0.4,0-2.1,0-4.2c0-3.6,0-8.3,0-10.2
                  c0-2.2,0.8-3,1.5-3.7C1.7,7.6,2,7.4,2.1,7.1c0.1-0.3,0.2-2.8,0.2-6.3c0-0.2,0.1-0.4,0.2-0.5C2.7,0.1,2.9,0,3.1,0h1.3
                  c0.2,0,0.4,0.1,0.5,0.2c0.1,0.1,0.2,0.3,0.2,0.5c0,3.6,0.1,6,0.2,6.3C5.5,7.4,5.8,7.6,6,7.9c0.7,0.7,1.5,1.5,1.5,3.7
                  c0,1.8,0,6.6,0,10.2c0,2.1,0,3.8,0,4.2v0.9c0,0.4-0.2,0.8-0.5,1.1C6.6,28.3,6.2,28.5,5.8,28.5z M3.1,0.5C3,0.5,3,0.5,2.9,0.6
                  c0,0-0.1,0.1-0.1,0.2C2.8,6.9,2.6,7.2,2.6,7.3C2.4,7.7,2.1,7.9,1.8,8.2c-0.6,0.7-1.3,1.4-1.3,3.4c0,1.8,0,6.6,0,10.2
                  c0,2.1,0,3.8,0,4.2v0.9c0,0.3,0.1,0.6,0.3,0.8C1.1,27.9,1.4,28,1.7,28h4c0.3,0,0.6-0.1,0.8-0.3c0.2-0.2,0.3-0.5,0.3-0.8V26
                  c0-0.4,0-2.1,0-4.2c0-3.6,0-8.3,0-10.2c0-2-0.7-2.7-1.3-3.4C5.4,7.9,5.1,7.7,4.9,7.3C4.9,7.2,4.7,6.9,4.6,0.7c0-0.1,0-0.1-0.1-0.2
                  c0,0-0.1-0.1-0.2-0.1H3.1z M5.4,7.1L5.4,7.1L5.4,7.1z"></path>
              </g>
              </svg>
            </li>
            <li>
            <svg version="1.1" class="white_carrot_bottle" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 7.5 28.5" style="enable-background:new 0 0 7.5 28.5;" xml:space="preserve">
            <g id="_x35_">
              <path class="bottle-trans" d="M5.2,7.2C5,6.9,4.9,2.2,4.9,0.7c0-0.1-0.1-0.2-0.2-0.3C4.6,0.3,4.5,0.3,4.4,0.3H3.1C3,0.3,2.8,0.3,2.8,0.4
                C2.7,0.5,2.6,0.6,2.6,0.7c0,1.5-0.1,6.1-0.3,6.4c-0.6,1.1-2.1,1.5-2.1,4.4c0,2.9,0.1,13.3,0.1,14.4v0.9c0,0.4,0.2,0.7,0.4,1
                c0.3,0.3,0.6,0.4,1,0.4h4c0.4,0,0.7-0.1,1-0.4c0.3-0.3,0.4-0.6,0.4-1V26c0-1,0.1-11.4,0.1-14.4C7.2,8.6,5.8,8.3,5.2,7.2z"></path>
              <path class="bottle-stroke" d="M5.8,28.5h-4c-0.5,0-0.9-0.2-1.2-0.5c-0.3-0.3-0.5-0.7-0.5-1.1V26c0-0.4,0-2.1,0-4.2c0-3.6,0-8.3,0-10.2
                c0-2.2,0.8-3,1.5-3.7C1.7,7.6,2,7.4,2.1,7.1c0.1-0.3,0.2-2.8,0.2-6.3c0-0.2,0.1-0.4,0.2-0.5C2.7,0.1,2.9,0,3.1,0h1.3
                c0.2,0,0.4,0.1,0.5,0.2c0.1,0.1,0.2,0.3,0.2,0.5c0,3.6,0.1,6,0.2,6.3C5.5,7.4,5.8,7.6,6,7.9c0.7,0.7,1.5,1.5,1.5,3.7
                c0,1.8,0,6.6,0,10.2c0,2.1,0,3.8,0,4.2v0.9c0,0.4-0.2,0.8-0.5,1.1C6.6,28.3,6.2,28.5,5.8,28.5z M3.1,0.5C3,0.5,3,0.5,2.9,0.6
                c0,0-0.1,0.1-0.1,0.2C2.8,6.9,2.6,7.2,2.6,7.3C2.4,7.7,2.1,7.9,1.8,8.2c-0.6,0.7-1.3,1.4-1.3,3.4c0,1.8,0,6.6,0,10.2
                c0,2.1,0,3.8,0,4.2v0.9c0,0.3,0.1,0.6,0.3,0.8C1.1,27.9,1.4,28,1.7,28h4c0.3,0,0.6-0.1,0.8-0.3c0.2-0.2,0.3-0.5,0.3-0.8V26
                c0-0.4,0-2.1,0-4.2c0-3.6,0-8.3,0-10.2c0-2-0.7-2.7-1.3-3.4C5.4,7.9,5.1,7.7,4.9,7.3C4.9,7.2,4.7,6.9,4.6,0.7c0-0.1,0-0.1-0.1-0.2
                c0,0-0.1-0.1-0.2-0.1H3.1z M5.4,7.1L5.4,7.1L5.4,7.1z"></path>
            </g>
            </svg>
          </li>
          <li>
          <svg version="1.1" class="white_carrot_bottle" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 7.5 28.5" style="enable-background:new 0 0 7.5 28.5;" xml:space="preserve">
          <g id="_x35_">
            <path class="bottle-trans" d="M5.2,7.2C5,6.9,4.9,2.2,4.9,0.7c0-0.1-0.1-0.2-0.2-0.3C4.6,0.3,4.5,0.3,4.4,0.3H3.1C3,0.3,2.8,0.3,2.8,0.4
              C2.7,0.5,2.6,0.6,2.6,0.7c0,1.5-0.1,6.1-0.3,6.4c-0.6,1.1-2.1,1.5-2.1,4.4c0,2.9,0.1,13.3,0.1,14.4v0.9c0,0.4,0.2,0.7,0.4,1
              c0.3,0.3,0.6,0.4,1,0.4h4c0.4,0,0.7-0.1,1-0.4c0.3-0.3,0.4-0.6,0.4-1V26c0-1,0.1-11.4,0.1-14.4C7.2,8.6,5.8,8.3,5.2,7.2z"></path>
            <path class="bottle-stroke" d="M5.8,28.5h-4c-0.5,0-0.9-0.2-1.2-0.5c-0.3-0.3-0.5-0.7-0.5-1.1V26c0-0.4,0-2.1,0-4.2c0-3.6,0-8.3,0-10.2
              c0-2.2,0.8-3,1.5-3.7C1.7,7.6,2,7.4,2.1,7.1c0.1-0.3,0.2-2.8,0.2-6.3c0-0.2,0.1-0.4,0.2-0.5C2.7,0.1,2.9,0,3.1,0h1.3
              c0.2,0,0.4,0.1,0.5,0.2c0.1,0.1,0.2,0.3,0.2,0.5c0,3.6,0.1,6,0.2,6.3C5.5,7.4,5.8,7.6,6,7.9c0.7,0.7,1.5,1.5,1.5,3.7
              c0,1.8,0,6.6,0,10.2c0,2.1,0,3.8,0,4.2v0.9c0,0.4-0.2,0.8-0.5,1.1C6.6,28.3,6.2,28.5,5.8,28.5z M3.1,0.5C3,0.5,3,0.5,2.9,0.6
              c0,0-0.1,0.1-0.1,0.2C2.8,6.9,2.6,7.2,2.6,7.3C2.4,7.7,2.1,7.9,1.8,8.2c-0.6,0.7-1.3,1.4-1.3,3.4c0,1.8,0,6.6,0,10.2
              c0,2.1,0,3.8,0,4.2v0.9c0,0.3,0.1,0.6,0.3,0.8C1.1,27.9,1.4,28,1.7,28h4c0.3,0,0.6-0.1,0.8-0.3c0.2-0.2,0.3-0.5,0.3-0.8V26
              c0-0.4,0-2.1,0-4.2c0-3.6,0-8.3,0-10.2c0-2-0.7-2.7-1.3-3.4C5.4,7.9,5.1,7.7,4.9,7.3C4.9,7.2,4.7,6.9,4.6,0.7c0-0.1,0-0.1-0.1-0.2
              c0,0-0.1-0.1-0.2-0.1H3.1z M5.4,7.1L5.4,7.1L5.4,7.1z"></path>
          </g>
          </svg>
        </li>
        <li>
        <svg version="1.1" class="white_carrot_bottle" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 7.5 28.5" style="enable-background:new 0 0 7.5 28.5;" xml:space="preserve">
        <g id="_x35_">
          <path class="bottle-trans" d="M5.2,7.2C5,6.9,4.9,2.2,4.9,0.7c0-0.1-0.1-0.2-0.2-0.3C4.6,0.3,4.5,0.3,4.4,0.3H3.1C3,0.3,2.8,0.3,2.8,0.4
            C2.7,0.5,2.6,0.6,2.6,0.7c0,1.5-0.1,6.1-0.3,6.4c-0.6,1.1-2.1,1.5-2.1,4.4c0,2.9,0.1,13.3,0.1,14.4v0.9c0,0.4,0.2,0.7,0.4,1
            c0.3,0.3,0.6,0.4,1,0.4h4c0.4,0,0.7-0.1,1-0.4c0.3-0.3,0.4-0.6,0.4-1V26c0-1,0.1-11.4,0.1-14.4C7.2,8.6,5.8,8.3,5.2,7.2z"></path>
          <path class="bottle-stroke" d="M5.8,28.5h-4c-0.5,0-0.9-0.2-1.2-0.5c-0.3-0.3-0.5-0.7-0.5-1.1V26c0-0.4,0-2.1,0-4.2c0-3.6,0-8.3,0-10.2
            c0-2.2,0.8-3,1.5-3.7C1.7,7.6,2,7.4,2.1,7.1c0.1-0.3,0.2-2.8,0.2-6.3c0-0.2,0.1-0.4,0.2-0.5C2.7,0.1,2.9,0,3.1,0h1.3
            c0.2,0,0.4,0.1,0.5,0.2c0.1,0.1,0.2,0.3,0.2,0.5c0,3.6,0.1,6,0.2,6.3C5.5,7.4,5.8,7.6,6,7.9c0.7,0.7,1.5,1.5,1.5,3.7
            c0,1.8,0,6.6,0,10.2c0,2.1,0,3.8,0,4.2v0.9c0,0.4-0.2,0.8-0.5,1.1C6.6,28.3,6.2,28.5,5.8,28.5z M3.1,0.5C3,0.5,3,0.5,2.9,0.6
            c0,0-0.1,0.1-0.1,0.2C2.8,6.9,2.6,7.2,2.6,7.3C2.4,7.7,2.1,7.9,1.8,8.2c-0.6,0.7-1.3,1.4-1.3,3.4c0,1.8,0,6.6,0,10.2
            c0,2.1,0,3.8,0,4.2v0.9c0,0.3,0.1,0.6,0.3,0.8C1.1,27.9,1.4,28,1.7,28h4c0.3,0,0.6-0.1,0.8-0.3c0.2-0.2,0.3-0.5,0.3-0.8V26
            c0-0.4,0-2.1,0-4.2c0-3.6,0-8.3,0-10.2c0-2-0.7-2.7-1.3-3.4C5.4,7.9,5.1,7.7,4.9,7.3C4.9,7.2,4.7,6.9,4.6,0.7c0-0.1,0-0.1-0.1-0.2
            c0,0-0.1-0.1-0.2-0.1H3.1z M5.4,7.1L5.4,7.1L5.4,7.1z"></path>
        </g>
        </svg>
      </li>
      <li>
      <svg version="1.1" class="white_carrot_bottle" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 7.5 28.5" style="enable-background:new 0 0 7.5 28.5;" xml:space="preserve">
      <g id="_x35_">
        <path class="bottle-trans" d="M5.2,7.2C5,6.9,4.9,2.2,4.9,0.7c0-0.1-0.1-0.2-0.2-0.3C4.6,0.3,4.5,0.3,4.4,0.3H3.1C3,0.3,2.8,0.3,2.8,0.4
          C2.7,0.5,2.6,0.6,2.6,0.7c0,1.5-0.1,6.1-0.3,6.4c-0.6,1.1-2.1,1.5-2.1,4.4c0,2.9,0.1,13.3,0.1,14.4v0.9c0,0.4,0.2,0.7,0.4,1
          c0.3,0.3,0.6,0.4,1,0.4h4c0.4,0,0.7-0.1,1-0.4c0.3-0.3,0.4-0.6,0.4-1V26c0-1,0.1-11.4,0.1-14.4C7.2,8.6,5.8,8.3,5.2,7.2z"></path>
        <path class="bottle-stroke" d="M5.8,28.5h-4c-0.5,0-0.9-0.2-1.2-0.5c-0.3-0.3-0.5-0.7-0.5-1.1V26c0-0.4,0-2.1,0-4.2c0-3.6,0-8.3,0-10.2
          c0-2.2,0.8-3,1.5-3.7C1.7,7.6,2,7.4,2.1,7.1c0.1-0.3,0.2-2.8,0.2-6.3c0-0.2,0.1-0.4,0.2-0.5C2.7,0.1,2.9,0,3.1,0h1.3
          c0.2,0,0.4,0.1,0.5,0.2c0.1,0.1,0.2,0.3,0.2,0.5c0,3.6,0.1,6,0.2,6.3C5.5,7.4,5.8,7.6,6,7.9c0.7,0.7,1.5,1.5,1.5,3.7
          c0,1.8,0,6.6,0,10.2c0,2.1,0,3.8,0,4.2v0.9c0,0.4-0.2,0.8-0.5,1.1C6.6,28.3,6.2,28.5,5.8,28.5z M3.1,0.5C3,0.5,3,0.5,2.9,0.6
          c0,0-0.1,0.1-0.1,0.2C2.8,6.9,2.6,7.2,2.6,7.3C2.4,7.7,2.1,7.9,1.8,8.2c-0.6,0.7-1.3,1.4-1.3,3.4c0,1.8,0,6.6,0,10.2
          c0,2.1,0,3.8,0,4.2v0.9c0,0.3,0.1,0.6,0.3,0.8C1.1,27.9,1.4,28,1.7,28h4c0.3,0,0.6-0.1,0.8-0.3c0.2-0.2,0.3-0.5,0.3-0.8V26
          c0-0.4,0-2.1,0-4.2c0-3.6,0-8.3,0-10.2c0-2-0.7-2.7-1.3-3.4C5.4,7.9,5.1,7.7,4.9,7.3C4.9,7.2,4.7,6.9,4.6,0.7c0-0.1,0-0.1-0.1-0.2
          c0,0-0.1-0.1-0.2-0.1H3.1z M5.4,7.1L5.4,7.1L5.4,7.1z"></path>
      </g>
      </svg>
      </li>


        </ul>

    </div>	
    `;

    let intervalId = setInterval(function() {
      let url = new URL(window.location);

      if (
        url.pathname.includes('club-membership/receipt') &&
        document.body.contains(document.querySelector('.c7-receipt__club-shipment')) &&
        document.body.contains(document.querySelector('.c7-order-items--shipment'))
      ) {
        let header = document.querySelector('.c7-confirmation--club .c7-receipt__header');
        //place clubcarrotMarkup after header
        if (header && !document.querySelector('.carrot-ctr.club-membership')) {
          header.insertAdjacentHTML('afterend', clubCarrotMarkup);
        }

        let totalQuantity = 0;

        let orderItems = document.querySelectorAll('.c7-order-items--shipment ul .c7-order-item');
        [...orderItems].forEach((item) => {
          //find quantity but throw out first number in string as it's the 7 in c7 span element
          let numberArray = item.querySelector('.c7-order-item__pricing .c7-order-item__quantity').innerHTML.match(/\d+/g);
          let quantity = numberArray[1];
          totalQuantity += parseInt(quantity);
        });

        Carrot.updateClubCarrot(totalQuantity);
      }
    }, 500);
  },
  updateClubCarrot: function(quantity) {
    if (!document.body.contains(document.querySelector('.carrot-ctr.main-ctr.club-membership .carrot-msg'))) return;

    let qty = quantity;
    let carrotMain = document.querySelector('.carrot-ctr.club-membership.main-ctr');
    let carrotMainMsg = document.querySelector('.carrot-ctr.main-ctr.club-membership .carrot-msg');
    let carrotMainBtls = document.querySelectorAll('.carrot-ctr.main-ctr.club-membership .bottle-ctr svg');

    // let carrotCartMsg = document.querySelector('.carrot-ctr.carrot-cart .carrot-msg');
    // let carrotCartBtls = document.querySelectorAll('.carrot-ctr.carrot-cart .bottle-ctr img');

    if (qty <= 0) {
      carrotMainMsg.innerText = 'Uncork 1 cent shipping with 6 bottles'; //'ONE CENT shipping on any 6+ bottles!'
    } else if (qty <= 5) {
      if (qty == 5) {
        carrotMainMsg.innerHTML = `You’re <strong>${6 - qty} bottle</strong> away from a shipping special!`;
      } else {
        carrotMainMsg.innerHTML = `You’re <strong>${6 - qty} bottles</strong> away from a shipping special!`;
      }
    } else {
      carrotMainMsg.innerText = `You’ve uncorked special shipping rates!`;
    }

    [...carrotMainBtls].forEach((element, index, array) => {
      let bottle = element;
      let fill = bottle.querySelector('.bottle-trans');

      if (index + 1 <= qty) {
        if (!bottle.classList.contains('fill')) {
          fill.classList.add('fill');
        }
      } else {
        fill.classList.remove('fill');
      }
    });
  },
  membershipDetailCarrot: function() {
    //seen on checkout of club membership
    //http://rombauer-2021.local/profile/club-membership/e2b0d4d6-658f-414d-bde5-500db50160a2

    let clubCarrotMarkup = `
    <div class="carrot-ctr main-ctr club-membership">
    <p class="carrot-msg">Uncork 1 cent shipping with 6 bottles</p>
        <ul class="bottle-ctr">
              <li>
                <svg version="1.1" class="white_carrot_bottle" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 7.5 28.5" style="enable-background:new 0 0 7.5 28.5;" xml:space="preserve">
                <g id="_x35_">
                  <path class="bottle-trans" d="M5.2,7.2C5,6.9,4.9,2.2,4.9,0.7c0-0.1-0.1-0.2-0.2-0.3C4.6,0.3,4.5,0.3,4.4,0.3H3.1C3,0.3,2.8,0.3,2.8,0.4
                    C2.7,0.5,2.6,0.6,2.6,0.7c0,1.5-0.1,6.1-0.3,6.4c-0.6,1.1-2.1,1.5-2.1,4.4c0,2.9,0.1,13.3,0.1,14.4v0.9c0,0.4,0.2,0.7,0.4,1
                    c0.3,0.3,0.6,0.4,1,0.4h4c0.4,0,0.7-0.1,1-0.4c0.3-0.3,0.4-0.6,0.4-1V26c0-1,0.1-11.4,0.1-14.4C7.2,8.6,5.8,8.3,5.2,7.2z"></path>
                  <path class="bottle-stroke" d="M5.8,28.5h-4c-0.5,0-0.9-0.2-1.2-0.5c-0.3-0.3-0.5-0.7-0.5-1.1V26c0-0.4,0-2.1,0-4.2c0-3.6,0-8.3,0-10.2
                    c0-2.2,0.8-3,1.5-3.7C1.7,7.6,2,7.4,2.1,7.1c0.1-0.3,0.2-2.8,0.2-6.3c0-0.2,0.1-0.4,0.2-0.5C2.7,0.1,2.9,0,3.1,0h1.3
                    c0.2,0,0.4,0.1,0.5,0.2c0.1,0.1,0.2,0.3,0.2,0.5c0,3.6,0.1,6,0.2,6.3C5.5,7.4,5.8,7.6,6,7.9c0.7,0.7,1.5,1.5,1.5,3.7
                    c0,1.8,0,6.6,0,10.2c0,2.1,0,3.8,0,4.2v0.9c0,0.4-0.2,0.8-0.5,1.1C6.6,28.3,6.2,28.5,5.8,28.5z M3.1,0.5C3,0.5,3,0.5,2.9,0.6
                    c0,0-0.1,0.1-0.1,0.2C2.8,6.9,2.6,7.2,2.6,7.3C2.4,7.7,2.1,7.9,1.8,8.2c-0.6,0.7-1.3,1.4-1.3,3.4c0,1.8,0,6.6,0,10.2
                    c0,2.1,0,3.8,0,4.2v0.9c0,0.3,0.1,0.6,0.3,0.8C1.1,27.9,1.4,28,1.7,28h4c0.3,0,0.6-0.1,0.8-0.3c0.2-0.2,0.3-0.5,0.3-0.8V26
                    c0-0.4,0-2.1,0-4.2c0-3.6,0-8.3,0-10.2c0-2-0.7-2.7-1.3-3.4C5.4,7.9,5.1,7.7,4.9,7.3C4.9,7.2,4.7,6.9,4.6,0.7c0-0.1,0-0.1-0.1-0.2
                    c0,0-0.1-0.1-0.2-0.1H3.1z M5.4,7.1L5.4,7.1L5.4,7.1z"></path>
                </g>
                </svg>
              </li>
              <li>
              <svg version="1.1" class="white_carrot_bottle" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 7.5 28.5" style="enable-background:new 0 0 7.5 28.5;" xml:space="preserve">
              <g id="_x35_">
                <path class="bottle-trans" d="M5.2,7.2C5,6.9,4.9,2.2,4.9,0.7c0-0.1-0.1-0.2-0.2-0.3C4.6,0.3,4.5,0.3,4.4,0.3H3.1C3,0.3,2.8,0.3,2.8,0.4
                  C2.7,0.5,2.6,0.6,2.6,0.7c0,1.5-0.1,6.1-0.3,6.4c-0.6,1.1-2.1,1.5-2.1,4.4c0,2.9,0.1,13.3,0.1,14.4v0.9c0,0.4,0.2,0.7,0.4,1
                  c0.3,0.3,0.6,0.4,1,0.4h4c0.4,0,0.7-0.1,1-0.4c0.3-0.3,0.4-0.6,0.4-1V26c0-1,0.1-11.4,0.1-14.4C7.2,8.6,5.8,8.3,5.2,7.2z"></path>
                <path class="bottle-stroke" d="M5.8,28.5h-4c-0.5,0-0.9-0.2-1.2-0.5c-0.3-0.3-0.5-0.7-0.5-1.1V26c0-0.4,0-2.1,0-4.2c0-3.6,0-8.3,0-10.2
                  c0-2.2,0.8-3,1.5-3.7C1.7,7.6,2,7.4,2.1,7.1c0.1-0.3,0.2-2.8,0.2-6.3c0-0.2,0.1-0.4,0.2-0.5C2.7,0.1,2.9,0,3.1,0h1.3
                  c0.2,0,0.4,0.1,0.5,0.2c0.1,0.1,0.2,0.3,0.2,0.5c0,3.6,0.1,6,0.2,6.3C5.5,7.4,5.8,7.6,6,7.9c0.7,0.7,1.5,1.5,1.5,3.7
                  c0,1.8,0,6.6,0,10.2c0,2.1,0,3.8,0,4.2v0.9c0,0.4-0.2,0.8-0.5,1.1C6.6,28.3,6.2,28.5,5.8,28.5z M3.1,0.5C3,0.5,3,0.5,2.9,0.6
                  c0,0-0.1,0.1-0.1,0.2C2.8,6.9,2.6,7.2,2.6,7.3C2.4,7.7,2.1,7.9,1.8,8.2c-0.6,0.7-1.3,1.4-1.3,3.4c0,1.8,0,6.6,0,10.2
                  c0,2.1,0,3.8,0,4.2v0.9c0,0.3,0.1,0.6,0.3,0.8C1.1,27.9,1.4,28,1.7,28h4c0.3,0,0.6-0.1,0.8-0.3c0.2-0.2,0.3-0.5,0.3-0.8V26
                  c0-0.4,0-2.1,0-4.2c0-3.6,0-8.3,0-10.2c0-2-0.7-2.7-1.3-3.4C5.4,7.9,5.1,7.7,4.9,7.3C4.9,7.2,4.7,6.9,4.6,0.7c0-0.1,0-0.1-0.1-0.2
                  c0,0-0.1-0.1-0.2-0.1H3.1z M5.4,7.1L5.4,7.1L5.4,7.1z"></path>
              </g>
              </svg>
            </li>
            <li>
            <svg version="1.1" class="white_carrot_bottle" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 7.5 28.5" style="enable-background:new 0 0 7.5 28.5;" xml:space="preserve">
            <g id="_x35_">
              <path class="bottle-trans" d="M5.2,7.2C5,6.9,4.9,2.2,4.9,0.7c0-0.1-0.1-0.2-0.2-0.3C4.6,0.3,4.5,0.3,4.4,0.3H3.1C3,0.3,2.8,0.3,2.8,0.4
                C2.7,0.5,2.6,0.6,2.6,0.7c0,1.5-0.1,6.1-0.3,6.4c-0.6,1.1-2.1,1.5-2.1,4.4c0,2.9,0.1,13.3,0.1,14.4v0.9c0,0.4,0.2,0.7,0.4,1
                c0.3,0.3,0.6,0.4,1,0.4h4c0.4,0,0.7-0.1,1-0.4c0.3-0.3,0.4-0.6,0.4-1V26c0-1,0.1-11.4,0.1-14.4C7.2,8.6,5.8,8.3,5.2,7.2z"></path>
              <path class="bottle-stroke" d="M5.8,28.5h-4c-0.5,0-0.9-0.2-1.2-0.5c-0.3-0.3-0.5-0.7-0.5-1.1V26c0-0.4,0-2.1,0-4.2c0-3.6,0-8.3,0-10.2
                c0-2.2,0.8-3,1.5-3.7C1.7,7.6,2,7.4,2.1,7.1c0.1-0.3,0.2-2.8,0.2-6.3c0-0.2,0.1-0.4,0.2-0.5C2.7,0.1,2.9,0,3.1,0h1.3
                c0.2,0,0.4,0.1,0.5,0.2c0.1,0.1,0.2,0.3,0.2,0.5c0,3.6,0.1,6,0.2,6.3C5.5,7.4,5.8,7.6,6,7.9c0.7,0.7,1.5,1.5,1.5,3.7
                c0,1.8,0,6.6,0,10.2c0,2.1,0,3.8,0,4.2v0.9c0,0.4-0.2,0.8-0.5,1.1C6.6,28.3,6.2,28.5,5.8,28.5z M3.1,0.5C3,0.5,3,0.5,2.9,0.6
                c0,0-0.1,0.1-0.1,0.2C2.8,6.9,2.6,7.2,2.6,7.3C2.4,7.7,2.1,7.9,1.8,8.2c-0.6,0.7-1.3,1.4-1.3,3.4c0,1.8,0,6.6,0,10.2
                c0,2.1,0,3.8,0,4.2v0.9c0,0.3,0.1,0.6,0.3,0.8C1.1,27.9,1.4,28,1.7,28h4c0.3,0,0.6-0.1,0.8-0.3c0.2-0.2,0.3-0.5,0.3-0.8V26
                c0-0.4,0-2.1,0-4.2c0-3.6,0-8.3,0-10.2c0-2-0.7-2.7-1.3-3.4C5.4,7.9,5.1,7.7,4.9,7.3C4.9,7.2,4.7,6.9,4.6,0.7c0-0.1,0-0.1-0.1-0.2
                c0,0-0.1-0.1-0.2-0.1H3.1z M5.4,7.1L5.4,7.1L5.4,7.1z"></path>
            </g>
            </svg>
          </li>
          <li>
          <svg version="1.1" class="white_carrot_bottle" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 7.5 28.5" style="enable-background:new 0 0 7.5 28.5;" xml:space="preserve">
          <g id="_x35_">
            <path class="bottle-trans" d="M5.2,7.2C5,6.9,4.9,2.2,4.9,0.7c0-0.1-0.1-0.2-0.2-0.3C4.6,0.3,4.5,0.3,4.4,0.3H3.1C3,0.3,2.8,0.3,2.8,0.4
              C2.7,0.5,2.6,0.6,2.6,0.7c0,1.5-0.1,6.1-0.3,6.4c-0.6,1.1-2.1,1.5-2.1,4.4c0,2.9,0.1,13.3,0.1,14.4v0.9c0,0.4,0.2,0.7,0.4,1
              c0.3,0.3,0.6,0.4,1,0.4h4c0.4,0,0.7-0.1,1-0.4c0.3-0.3,0.4-0.6,0.4-1V26c0-1,0.1-11.4,0.1-14.4C7.2,8.6,5.8,8.3,5.2,7.2z"></path>
            <path class="bottle-stroke" d="M5.8,28.5h-4c-0.5,0-0.9-0.2-1.2-0.5c-0.3-0.3-0.5-0.7-0.5-1.1V26c0-0.4,0-2.1,0-4.2c0-3.6,0-8.3,0-10.2
              c0-2.2,0.8-3,1.5-3.7C1.7,7.6,2,7.4,2.1,7.1c0.1-0.3,0.2-2.8,0.2-6.3c0-0.2,0.1-0.4,0.2-0.5C2.7,0.1,2.9,0,3.1,0h1.3
              c0.2,0,0.4,0.1,0.5,0.2c0.1,0.1,0.2,0.3,0.2,0.5c0,3.6,0.1,6,0.2,6.3C5.5,7.4,5.8,7.6,6,7.9c0.7,0.7,1.5,1.5,1.5,3.7
              c0,1.8,0,6.6,0,10.2c0,2.1,0,3.8,0,4.2v0.9c0,0.4-0.2,0.8-0.5,1.1C6.6,28.3,6.2,28.5,5.8,28.5z M3.1,0.5C3,0.5,3,0.5,2.9,0.6
              c0,0-0.1,0.1-0.1,0.2C2.8,6.9,2.6,7.2,2.6,7.3C2.4,7.7,2.1,7.9,1.8,8.2c-0.6,0.7-1.3,1.4-1.3,3.4c0,1.8,0,6.6,0,10.2
              c0,2.1,0,3.8,0,4.2v0.9c0,0.3,0.1,0.6,0.3,0.8C1.1,27.9,1.4,28,1.7,28h4c0.3,0,0.6-0.1,0.8-0.3c0.2-0.2,0.3-0.5,0.3-0.8V26
              c0-0.4,0-2.1,0-4.2c0-3.6,0-8.3,0-10.2c0-2-0.7-2.7-1.3-3.4C5.4,7.9,5.1,7.7,4.9,7.3C4.9,7.2,4.7,6.9,4.6,0.7c0-0.1,0-0.1-0.1-0.2
              c0,0-0.1-0.1-0.2-0.1H3.1z M5.4,7.1L5.4,7.1L5.4,7.1z"></path>
          </g>
          </svg>
        </li>
        <li>
        <svg version="1.1" class="white_carrot_bottle" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 7.5 28.5" style="enable-background:new 0 0 7.5 28.5;" xml:space="preserve">
        <g id="_x35_">
          <path class="bottle-trans" d="M5.2,7.2C5,6.9,4.9,2.2,4.9,0.7c0-0.1-0.1-0.2-0.2-0.3C4.6,0.3,4.5,0.3,4.4,0.3H3.1C3,0.3,2.8,0.3,2.8,0.4
            C2.7,0.5,2.6,0.6,2.6,0.7c0,1.5-0.1,6.1-0.3,6.4c-0.6,1.1-2.1,1.5-2.1,4.4c0,2.9,0.1,13.3,0.1,14.4v0.9c0,0.4,0.2,0.7,0.4,1
            c0.3,0.3,0.6,0.4,1,0.4h4c0.4,0,0.7-0.1,1-0.4c0.3-0.3,0.4-0.6,0.4-1V26c0-1,0.1-11.4,0.1-14.4C7.2,8.6,5.8,8.3,5.2,7.2z"></path>
          <path class="bottle-stroke" d="M5.8,28.5h-4c-0.5,0-0.9-0.2-1.2-0.5c-0.3-0.3-0.5-0.7-0.5-1.1V26c0-0.4,0-2.1,0-4.2c0-3.6,0-8.3,0-10.2
            c0-2.2,0.8-3,1.5-3.7C1.7,7.6,2,7.4,2.1,7.1c0.1-0.3,0.2-2.8,0.2-6.3c0-0.2,0.1-0.4,0.2-0.5C2.7,0.1,2.9,0,3.1,0h1.3
            c0.2,0,0.4,0.1,0.5,0.2c0.1,0.1,0.2,0.3,0.2,0.5c0,3.6,0.1,6,0.2,6.3C5.5,7.4,5.8,7.6,6,7.9c0.7,0.7,1.5,1.5,1.5,3.7
            c0,1.8,0,6.6,0,10.2c0,2.1,0,3.8,0,4.2v0.9c0,0.4-0.2,0.8-0.5,1.1C6.6,28.3,6.2,28.5,5.8,28.5z M3.1,0.5C3,0.5,3,0.5,2.9,0.6
            c0,0-0.1,0.1-0.1,0.2C2.8,6.9,2.6,7.2,2.6,7.3C2.4,7.7,2.1,7.9,1.8,8.2c-0.6,0.7-1.3,1.4-1.3,3.4c0,1.8,0,6.6,0,10.2
            c0,2.1,0,3.8,0,4.2v0.9c0,0.3,0.1,0.6,0.3,0.8C1.1,27.9,1.4,28,1.7,28h4c0.3,0,0.6-0.1,0.8-0.3c0.2-0.2,0.3-0.5,0.3-0.8V26
            c0-0.4,0-2.1,0-4.2c0-3.6,0-8.3,0-10.2c0-2-0.7-2.7-1.3-3.4C5.4,7.9,5.1,7.7,4.9,7.3C4.9,7.2,4.7,6.9,4.6,0.7c0-0.1,0-0.1-0.1-0.2
            c0,0-0.1-0.1-0.2-0.1H3.1z M5.4,7.1L5.4,7.1L5.4,7.1z"></path>
        </g>
        </svg>
      </li>
      <li>
      <svg version="1.1" class="white_carrot_bottle" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 7.5 28.5" style="enable-background:new 0 0 7.5 28.5;" xml:space="preserve">
      <g id="_x35_">
        <path class="bottle-trans" d="M5.2,7.2C5,6.9,4.9,2.2,4.9,0.7c0-0.1-0.1-0.2-0.2-0.3C4.6,0.3,4.5,0.3,4.4,0.3H3.1C3,0.3,2.8,0.3,2.8,0.4
          C2.7,0.5,2.6,0.6,2.6,0.7c0,1.5-0.1,6.1-0.3,6.4c-0.6,1.1-2.1,1.5-2.1,4.4c0,2.9,0.1,13.3,0.1,14.4v0.9c0,0.4,0.2,0.7,0.4,1
          c0.3,0.3,0.6,0.4,1,0.4h4c0.4,0,0.7-0.1,1-0.4c0.3-0.3,0.4-0.6,0.4-1V26c0-1,0.1-11.4,0.1-14.4C7.2,8.6,5.8,8.3,5.2,7.2z"></path>
        <path class="bottle-stroke" d="M5.8,28.5h-4c-0.5,0-0.9-0.2-1.2-0.5c-0.3-0.3-0.5-0.7-0.5-1.1V26c0-0.4,0-2.1,0-4.2c0-3.6,0-8.3,0-10.2
          c0-2.2,0.8-3,1.5-3.7C1.7,7.6,2,7.4,2.1,7.1c0.1-0.3,0.2-2.8,0.2-6.3c0-0.2,0.1-0.4,0.2-0.5C2.7,0.1,2.9,0,3.1,0h1.3
          c0.2,0,0.4,0.1,0.5,0.2c0.1,0.1,0.2,0.3,0.2,0.5c0,3.6,0.1,6,0.2,6.3C5.5,7.4,5.8,7.6,6,7.9c0.7,0.7,1.5,1.5,1.5,3.7
          c0,1.8,0,6.6,0,10.2c0,2.1,0,3.8,0,4.2v0.9c0,0.4-0.2,0.8-0.5,1.1C6.6,28.3,6.2,28.5,5.8,28.5z M3.1,0.5C3,0.5,3,0.5,2.9,0.6
          c0,0-0.1,0.1-0.1,0.2C2.8,6.9,2.6,7.2,2.6,7.3C2.4,7.7,2.1,7.9,1.8,8.2c-0.6,0.7-1.3,1.4-1.3,3.4c0,1.8,0,6.6,0,10.2
          c0,2.1,0,3.8,0,4.2v0.9c0,0.3,0.1,0.6,0.3,0.8C1.1,27.9,1.4,28,1.7,28h4c0.3,0,0.6-0.1,0.8-0.3c0.2-0.2,0.3-0.5,0.3-0.8V26
          c0-0.4,0-2.1,0-4.2c0-3.6,0-8.3,0-10.2c0-2-0.7-2.7-1.3-3.4C5.4,7.9,5.1,7.7,4.9,7.3C4.9,7.2,4.7,6.9,4.6,0.7c0-0.1,0-0.1-0.1-0.2
          c0,0-0.1-0.1-0.2-0.1H3.1z M5.4,7.1L5.4,7.1L5.4,7.1z"></path>
      </g>
      </svg>
      </li>


        </ul>

    </div>	
    `;

    let intervalId = setInterval(function() {
      let url = new URL(window.location);

      if (
        url.pathname.includes('/profile/club-membership') &&
        document.body.contains(document.querySelector('.c7-account-details--membership')) &&
        document.body.contains(document.querySelector('.c7-order-items--shipment'))
      ) {
        let header = document.querySelector('.c7-account-details--membership');
        //place clubcarrotMarkup after header
        if (header && !document.querySelector('.carrot-ctr.club-membership')) {
          header.insertAdjacentHTML('beforebegin', clubCarrotMarkup);
        }

        let totalQuantity = 0;

        let orderItems = document.querySelectorAll('.c7-order-items--shipment ul .c7-order-item');
        [...orderItems].forEach((item) => {
          //find quantity but throw out first number in string as it's the 7 in c7 span element
          let numberArray = item.querySelector('.c7-order-item__pricing .c7-order-item__quantity').innerHTML.match(/\d+/g);
          let quantity = numberArray[1];
          totalQuantity += parseInt(quantity);
        });

        Carrot.updateClubCarrot(totalQuantity);
      }
    }, 500);
  },
  updateMembershipCarrot: function(totalQuantity) {
    if (!document.body.contains(document.querySelector('.carrot-ctr.main-ctr.club-membership .carrot-msg'))) return;

    let qty = totalQuantity;
    let carrotMain = document.querySelector('.carrot-ctr.club-membership.main-ctr');
    let carrotMainMsg = document.querySelector('.carrot-ctr.main-ctr.club-membership .carrot-msg');
    let carrotMainBtls = document.querySelectorAll('.carrot-ctr.main-ctr.club-membership .bottle-ctr svg');

    // let carrotCartMsg = document.querySelector('.carrot-ctr.carrot-cart .carrot-msg');
    // let carrotCartBtls = document.querySelectorAll('.carrot-ctr.carrot-cart .bottle-ctr img');

    if (qty <= 0) {
      carrotMainMsg.innerText = 'Uncork 1 cent shipping with 6 bottles'; //'ONE CENT shipping on any 6+ bottles!'
    } else if (qty <= 5) {
      if (qty == 5) {
        carrotMainMsg.innerHTML = `You’re <strong>${6 - qty} bottle</strong> away from a shipping special!`;
      } else {
        carrotMainMsg.innerHTML = `You’re <strong>${6 - qty} bottles</strong> away from a shipping special!`;
      }
    } else {
      carrotMainMsg.innerText = `You’ve uncorked special shipping rates!`;
    }

    [...carrotMainBtls].forEach((element, index, array) => {
      let bottle = element;
      let fill = bottle.querySelector('.bottle-trans');

      if (index + 1 <= qty) {
        if (!bottle.classList.contains('fill')) {
          fill.classList.add('fill');
        }
      } else {
        fill.classList.remove('fill');
      }
    });
  },
  clubCheckoutCarrot: function() {
    //seen on checkout of club membership
    //http://rombauer-2021.local/profile/club-membership/e2b0d4d6-658f-414d-bde5-500db50160a2

    let clubCarrotMarkup = `
    <div class="carrot-ctr main-ctr club-checkout">
    <p class="carrot-msg">Uncork 1 cent shipping with 6 bottles</p>
        <ul class="bottle-ctr">
              <li>
                <svg version="1.1" class="white_carrot_bottle" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 7.5 28.5" style="enable-background:new 0 0 7.5 28.5;" xml:space="preserve">
                <g id="_x35_">
                  <path class="bottle-trans" d="M5.2,7.2C5,6.9,4.9,2.2,4.9,0.7c0-0.1-0.1-0.2-0.2-0.3C4.6,0.3,4.5,0.3,4.4,0.3H3.1C3,0.3,2.8,0.3,2.8,0.4
                    C2.7,0.5,2.6,0.6,2.6,0.7c0,1.5-0.1,6.1-0.3,6.4c-0.6,1.1-2.1,1.5-2.1,4.4c0,2.9,0.1,13.3,0.1,14.4v0.9c0,0.4,0.2,0.7,0.4,1
                    c0.3,0.3,0.6,0.4,1,0.4h4c0.4,0,0.7-0.1,1-0.4c0.3-0.3,0.4-0.6,0.4-1V26c0-1,0.1-11.4,0.1-14.4C7.2,8.6,5.8,8.3,5.2,7.2z"></path>
                  <path class="bottle-stroke" d="M5.8,28.5h-4c-0.5,0-0.9-0.2-1.2-0.5c-0.3-0.3-0.5-0.7-0.5-1.1V26c0-0.4,0-2.1,0-4.2c0-3.6,0-8.3,0-10.2
                    c0-2.2,0.8-3,1.5-3.7C1.7,7.6,2,7.4,2.1,7.1c0.1-0.3,0.2-2.8,0.2-6.3c0-0.2,0.1-0.4,0.2-0.5C2.7,0.1,2.9,0,3.1,0h1.3
                    c0.2,0,0.4,0.1,0.5,0.2c0.1,0.1,0.2,0.3,0.2,0.5c0,3.6,0.1,6,0.2,6.3C5.5,7.4,5.8,7.6,6,7.9c0.7,0.7,1.5,1.5,1.5,3.7
                    c0,1.8,0,6.6,0,10.2c0,2.1,0,3.8,0,4.2v0.9c0,0.4-0.2,0.8-0.5,1.1C6.6,28.3,6.2,28.5,5.8,28.5z M3.1,0.5C3,0.5,3,0.5,2.9,0.6
                    c0,0-0.1,0.1-0.1,0.2C2.8,6.9,2.6,7.2,2.6,7.3C2.4,7.7,2.1,7.9,1.8,8.2c-0.6,0.7-1.3,1.4-1.3,3.4c0,1.8,0,6.6,0,10.2
                    c0,2.1,0,3.8,0,4.2v0.9c0,0.3,0.1,0.6,0.3,0.8C1.1,27.9,1.4,28,1.7,28h4c0.3,0,0.6-0.1,0.8-0.3c0.2-0.2,0.3-0.5,0.3-0.8V26
                    c0-0.4,0-2.1,0-4.2c0-3.6,0-8.3,0-10.2c0-2-0.7-2.7-1.3-3.4C5.4,7.9,5.1,7.7,4.9,7.3C4.9,7.2,4.7,6.9,4.6,0.7c0-0.1,0-0.1-0.1-0.2
                    c0,0-0.1-0.1-0.2-0.1H3.1z M5.4,7.1L5.4,7.1L5.4,7.1z"></path>
                </g>
                </svg>
              </li>
              <li>
              <svg version="1.1" class="white_carrot_bottle" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 7.5 28.5" style="enable-background:new 0 0 7.5 28.5;" xml:space="preserve">
              <g id="_x35_">
                <path class="bottle-trans" d="M5.2,7.2C5,6.9,4.9,2.2,4.9,0.7c0-0.1-0.1-0.2-0.2-0.3C4.6,0.3,4.5,0.3,4.4,0.3H3.1C3,0.3,2.8,0.3,2.8,0.4
                  C2.7,0.5,2.6,0.6,2.6,0.7c0,1.5-0.1,6.1-0.3,6.4c-0.6,1.1-2.1,1.5-2.1,4.4c0,2.9,0.1,13.3,0.1,14.4v0.9c0,0.4,0.2,0.7,0.4,1
                  c0.3,0.3,0.6,0.4,1,0.4h4c0.4,0,0.7-0.1,1-0.4c0.3-0.3,0.4-0.6,0.4-1V26c0-1,0.1-11.4,0.1-14.4C7.2,8.6,5.8,8.3,5.2,7.2z"></path>
                <path class="bottle-stroke" d="M5.8,28.5h-4c-0.5,0-0.9-0.2-1.2-0.5c-0.3-0.3-0.5-0.7-0.5-1.1V26c0-0.4,0-2.1,0-4.2c0-3.6,0-8.3,0-10.2
                  c0-2.2,0.8-3,1.5-3.7C1.7,7.6,2,7.4,2.1,7.1c0.1-0.3,0.2-2.8,0.2-6.3c0-0.2,0.1-0.4,0.2-0.5C2.7,0.1,2.9,0,3.1,0h1.3
                  c0.2,0,0.4,0.1,0.5,0.2c0.1,0.1,0.2,0.3,0.2,0.5c0,3.6,0.1,6,0.2,6.3C5.5,7.4,5.8,7.6,6,7.9c0.7,0.7,1.5,1.5,1.5,3.7
                  c0,1.8,0,6.6,0,10.2c0,2.1,0,3.8,0,4.2v0.9c0,0.4-0.2,0.8-0.5,1.1C6.6,28.3,6.2,28.5,5.8,28.5z M3.1,0.5C3,0.5,3,0.5,2.9,0.6
                  c0,0-0.1,0.1-0.1,0.2C2.8,6.9,2.6,7.2,2.6,7.3C2.4,7.7,2.1,7.9,1.8,8.2c-0.6,0.7-1.3,1.4-1.3,3.4c0,1.8,0,6.6,0,10.2
                  c0,2.1,0,3.8,0,4.2v0.9c0,0.3,0.1,0.6,0.3,0.8C1.1,27.9,1.4,28,1.7,28h4c0.3,0,0.6-0.1,0.8-0.3c0.2-0.2,0.3-0.5,0.3-0.8V26
                  c0-0.4,0-2.1,0-4.2c0-3.6,0-8.3,0-10.2c0-2-0.7-2.7-1.3-3.4C5.4,7.9,5.1,7.7,4.9,7.3C4.9,7.2,4.7,6.9,4.6,0.7c0-0.1,0-0.1-0.1-0.2
                  c0,0-0.1-0.1-0.2-0.1H3.1z M5.4,7.1L5.4,7.1L5.4,7.1z"></path>
              </g>
              </svg>
            </li>
            <li>
            <svg version="1.1" class="white_carrot_bottle" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 7.5 28.5" style="enable-background:new 0 0 7.5 28.5;" xml:space="preserve">
            <g id="_x35_">
              <path class="bottle-trans" d="M5.2,7.2C5,6.9,4.9,2.2,4.9,0.7c0-0.1-0.1-0.2-0.2-0.3C4.6,0.3,4.5,0.3,4.4,0.3H3.1C3,0.3,2.8,0.3,2.8,0.4
                C2.7,0.5,2.6,0.6,2.6,0.7c0,1.5-0.1,6.1-0.3,6.4c-0.6,1.1-2.1,1.5-2.1,4.4c0,2.9,0.1,13.3,0.1,14.4v0.9c0,0.4,0.2,0.7,0.4,1
                c0.3,0.3,0.6,0.4,1,0.4h4c0.4,0,0.7-0.1,1-0.4c0.3-0.3,0.4-0.6,0.4-1V26c0-1,0.1-11.4,0.1-14.4C7.2,8.6,5.8,8.3,5.2,7.2z"></path>
              <path class="bottle-stroke" d="M5.8,28.5h-4c-0.5,0-0.9-0.2-1.2-0.5c-0.3-0.3-0.5-0.7-0.5-1.1V26c0-0.4,0-2.1,0-4.2c0-3.6,0-8.3,0-10.2
                c0-2.2,0.8-3,1.5-3.7C1.7,7.6,2,7.4,2.1,7.1c0.1-0.3,0.2-2.8,0.2-6.3c0-0.2,0.1-0.4,0.2-0.5C2.7,0.1,2.9,0,3.1,0h1.3
                c0.2,0,0.4,0.1,0.5,0.2c0.1,0.1,0.2,0.3,0.2,0.5c0,3.6,0.1,6,0.2,6.3C5.5,7.4,5.8,7.6,6,7.9c0.7,0.7,1.5,1.5,1.5,3.7
                c0,1.8,0,6.6,0,10.2c0,2.1,0,3.8,0,4.2v0.9c0,0.4-0.2,0.8-0.5,1.1C6.6,28.3,6.2,28.5,5.8,28.5z M3.1,0.5C3,0.5,3,0.5,2.9,0.6
                c0,0-0.1,0.1-0.1,0.2C2.8,6.9,2.6,7.2,2.6,7.3C2.4,7.7,2.1,7.9,1.8,8.2c-0.6,0.7-1.3,1.4-1.3,3.4c0,1.8,0,6.6,0,10.2
                c0,2.1,0,3.8,0,4.2v0.9c0,0.3,0.1,0.6,0.3,0.8C1.1,27.9,1.4,28,1.7,28h4c0.3,0,0.6-0.1,0.8-0.3c0.2-0.2,0.3-0.5,0.3-0.8V26
                c0-0.4,0-2.1,0-4.2c0-3.6,0-8.3,0-10.2c0-2-0.7-2.7-1.3-3.4C5.4,7.9,5.1,7.7,4.9,7.3C4.9,7.2,4.7,6.9,4.6,0.7c0-0.1,0-0.1-0.1-0.2
                c0,0-0.1-0.1-0.2-0.1H3.1z M5.4,7.1L5.4,7.1L5.4,7.1z"></path>
            </g>
            </svg>
          </li>
          <li>
          <svg version="1.1" class="white_carrot_bottle" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 7.5 28.5" style="enable-background:new 0 0 7.5 28.5;" xml:space="preserve">
          <g id="_x35_">
            <path class="bottle-trans" d="M5.2,7.2C5,6.9,4.9,2.2,4.9,0.7c0-0.1-0.1-0.2-0.2-0.3C4.6,0.3,4.5,0.3,4.4,0.3H3.1C3,0.3,2.8,0.3,2.8,0.4
              C2.7,0.5,2.6,0.6,2.6,0.7c0,1.5-0.1,6.1-0.3,6.4c-0.6,1.1-2.1,1.5-2.1,4.4c0,2.9,0.1,13.3,0.1,14.4v0.9c0,0.4,0.2,0.7,0.4,1
              c0.3,0.3,0.6,0.4,1,0.4h4c0.4,0,0.7-0.1,1-0.4c0.3-0.3,0.4-0.6,0.4-1V26c0-1,0.1-11.4,0.1-14.4C7.2,8.6,5.8,8.3,5.2,7.2z"></path>
            <path class="bottle-stroke" d="M5.8,28.5h-4c-0.5,0-0.9-0.2-1.2-0.5c-0.3-0.3-0.5-0.7-0.5-1.1V26c0-0.4,0-2.1,0-4.2c0-3.6,0-8.3,0-10.2
              c0-2.2,0.8-3,1.5-3.7C1.7,7.6,2,7.4,2.1,7.1c0.1-0.3,0.2-2.8,0.2-6.3c0-0.2,0.1-0.4,0.2-0.5C2.7,0.1,2.9,0,3.1,0h1.3
              c0.2,0,0.4,0.1,0.5,0.2c0.1,0.1,0.2,0.3,0.2,0.5c0,3.6,0.1,6,0.2,6.3C5.5,7.4,5.8,7.6,6,7.9c0.7,0.7,1.5,1.5,1.5,3.7
              c0,1.8,0,6.6,0,10.2c0,2.1,0,3.8,0,4.2v0.9c0,0.4-0.2,0.8-0.5,1.1C6.6,28.3,6.2,28.5,5.8,28.5z M3.1,0.5C3,0.5,3,0.5,2.9,0.6
              c0,0-0.1,0.1-0.1,0.2C2.8,6.9,2.6,7.2,2.6,7.3C2.4,7.7,2.1,7.9,1.8,8.2c-0.6,0.7-1.3,1.4-1.3,3.4c0,1.8,0,6.6,0,10.2
              c0,2.1,0,3.8,0,4.2v0.9c0,0.3,0.1,0.6,0.3,0.8C1.1,27.9,1.4,28,1.7,28h4c0.3,0,0.6-0.1,0.8-0.3c0.2-0.2,0.3-0.5,0.3-0.8V26
              c0-0.4,0-2.1,0-4.2c0-3.6,0-8.3,0-10.2c0-2-0.7-2.7-1.3-3.4C5.4,7.9,5.1,7.7,4.9,7.3C4.9,7.2,4.7,6.9,4.6,0.7c0-0.1,0-0.1-0.1-0.2
              c0,0-0.1-0.1-0.2-0.1H3.1z M5.4,7.1L5.4,7.1L5.4,7.1z"></path>
          </g>
          </svg>
        </li>
        <li>
        <svg version="1.1" class="white_carrot_bottle" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 7.5 28.5" style="enable-background:new 0 0 7.5 28.5;" xml:space="preserve">
        <g id="_x35_">
          <path class="bottle-trans" d="M5.2,7.2C5,6.9,4.9,2.2,4.9,0.7c0-0.1-0.1-0.2-0.2-0.3C4.6,0.3,4.5,0.3,4.4,0.3H3.1C3,0.3,2.8,0.3,2.8,0.4
            C2.7,0.5,2.6,0.6,2.6,0.7c0,1.5-0.1,6.1-0.3,6.4c-0.6,1.1-2.1,1.5-2.1,4.4c0,2.9,0.1,13.3,0.1,14.4v0.9c0,0.4,0.2,0.7,0.4,1
            c0.3,0.3,0.6,0.4,1,0.4h4c0.4,0,0.7-0.1,1-0.4c0.3-0.3,0.4-0.6,0.4-1V26c0-1,0.1-11.4,0.1-14.4C7.2,8.6,5.8,8.3,5.2,7.2z"></path>
          <path class="bottle-stroke" d="M5.8,28.5h-4c-0.5,0-0.9-0.2-1.2-0.5c-0.3-0.3-0.5-0.7-0.5-1.1V26c0-0.4,0-2.1,0-4.2c0-3.6,0-8.3,0-10.2
            c0-2.2,0.8-3,1.5-3.7C1.7,7.6,2,7.4,2.1,7.1c0.1-0.3,0.2-2.8,0.2-6.3c0-0.2,0.1-0.4,0.2-0.5C2.7,0.1,2.9,0,3.1,0h1.3
            c0.2,0,0.4,0.1,0.5,0.2c0.1,0.1,0.2,0.3,0.2,0.5c0,3.6,0.1,6,0.2,6.3C5.5,7.4,5.8,7.6,6,7.9c0.7,0.7,1.5,1.5,1.5,3.7
            c0,1.8,0,6.6,0,10.2c0,2.1,0,3.8,0,4.2v0.9c0,0.4-0.2,0.8-0.5,1.1C6.6,28.3,6.2,28.5,5.8,28.5z M3.1,0.5C3,0.5,3,0.5,2.9,0.6
            c0,0-0.1,0.1-0.1,0.2C2.8,6.9,2.6,7.2,2.6,7.3C2.4,7.7,2.1,7.9,1.8,8.2c-0.6,0.7-1.3,1.4-1.3,3.4c0,1.8,0,6.6,0,10.2
            c0,2.1,0,3.8,0,4.2v0.9c0,0.3,0.1,0.6,0.3,0.8C1.1,27.9,1.4,28,1.7,28h4c0.3,0,0.6-0.1,0.8-0.3c0.2-0.2,0.3-0.5,0.3-0.8V26
            c0-0.4,0-2.1,0-4.2c0-3.6,0-8.3,0-10.2c0-2-0.7-2.7-1.3-3.4C5.4,7.9,5.1,7.7,4.9,7.3C4.9,7.2,4.7,6.9,4.6,0.7c0-0.1,0-0.1-0.1-0.2
            c0,0-0.1-0.1-0.2-0.1H3.1z M5.4,7.1L5.4,7.1L5.4,7.1z"></path>
        </g>
        </svg>
      </li>
      <li>
      <svg version="1.1" class="white_carrot_bottle" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 7.5 28.5" style="enable-background:new 0 0 7.5 28.5;" xml:space="preserve">
      <g id="_x35_">
        <path class="bottle-trans" d="M5.2,7.2C5,6.9,4.9,2.2,4.9,0.7c0-0.1-0.1-0.2-0.2-0.3C4.6,0.3,4.5,0.3,4.4,0.3H3.1C3,0.3,2.8,0.3,2.8,0.4
          C2.7,0.5,2.6,0.6,2.6,0.7c0,1.5-0.1,6.1-0.3,6.4c-0.6,1.1-2.1,1.5-2.1,4.4c0,2.9,0.1,13.3,0.1,14.4v0.9c0,0.4,0.2,0.7,0.4,1
          c0.3,0.3,0.6,0.4,1,0.4h4c0.4,0,0.7-0.1,1-0.4c0.3-0.3,0.4-0.6,0.4-1V26c0-1,0.1-11.4,0.1-14.4C7.2,8.6,5.8,8.3,5.2,7.2z"></path>
        <path class="bottle-stroke" d="M5.8,28.5h-4c-0.5,0-0.9-0.2-1.2-0.5c-0.3-0.3-0.5-0.7-0.5-1.1V26c0-0.4,0-2.1,0-4.2c0-3.6,0-8.3,0-10.2
          c0-2.2,0.8-3,1.5-3.7C1.7,7.6,2,7.4,2.1,7.1c0.1-0.3,0.2-2.8,0.2-6.3c0-0.2,0.1-0.4,0.2-0.5C2.7,0.1,2.9,0,3.1,0h1.3
          c0.2,0,0.4,0.1,0.5,0.2c0.1,0.1,0.2,0.3,0.2,0.5c0,3.6,0.1,6,0.2,6.3C5.5,7.4,5.8,7.6,6,7.9c0.7,0.7,1.5,1.5,1.5,3.7
          c0,1.8,0,6.6,0,10.2c0,2.1,0,3.8,0,4.2v0.9c0,0.4-0.2,0.8-0.5,1.1C6.6,28.3,6.2,28.5,5.8,28.5z M3.1,0.5C3,0.5,3,0.5,2.9,0.6
          c0,0-0.1,0.1-0.1,0.2C2.8,6.9,2.6,7.2,2.6,7.3C2.4,7.7,2.1,7.9,1.8,8.2c-0.6,0.7-1.3,1.4-1.3,3.4c0,1.8,0,6.6,0,10.2
          c0,2.1,0,3.8,0,4.2v0.9c0,0.3,0.1,0.6,0.3,0.8C1.1,27.9,1.4,28,1.7,28h4c0.3,0,0.6-0.1,0.8-0.3c0.2-0.2,0.3-0.5,0.3-0.8V26
          c0-0.4,0-2.1,0-4.2c0-3.6,0-8.3,0-10.2c0-2-0.7-2.7-1.3-3.4C5.4,7.9,5.1,7.7,4.9,7.3C4.9,7.2,4.7,6.9,4.6,0.7c0-0.1,0-0.1-0.1-0.2
          c0,0-0.1-0.1-0.2-0.1H3.1z M5.4,7.1L5.4,7.1L5.4,7.1z"></path>
      </g>
      </svg>
      </li>


        </ul>

    </div>	
    `;

    let intervalId = setInterval(function() {
      let url = new URL(window.location);

      if (url.pathname.includes('/checkout/club/product') && document.body.contains(document.querySelector('.c7-checkout--club.c7-checkout--club--products'))) {
        let header = document.querySelector('.c7-checkout__content');
        //place clubcarrotMarkup after header
        if (header && !document.querySelector('.carrot-ctr.club-checkout')) {
          header.insertAdjacentHTML('beforebegin', clubCarrotMarkup);
        }

        document.querySelector('.carrot-ctr.main-ctr.club-checkout').classList.remove('hide');

        let totalQuantity = 0;

        let orderItems = document.querySelectorAll('#c7-checkout-summary .c7-order-items ul .c7-order-item');
        [...orderItems].forEach((item) => {
          //find quantity but throw out first number in string as it's the 7 in c7 span element
          let numberArray = item.querySelector('.c7-order-item__pricing .c7-order-item__quantity').innerHTML.match(/\d+/g);
          let quantity = numberArray[1];
          totalQuantity += parseInt(quantity);
        });

        console.log(totalQuantity);

        Carrot.updateClubCheckoutCarrot(totalQuantity);
      } else {
        //so bottles are not seen on other pages
        if (!url.pathname.includes('/checkout/club/product') && document.body.contains(document.querySelector('.carrot-ctr.main-ctr.club-checkout'))) {
          document.querySelector('.carrot-ctr.main-ctr.club-checkout').classList.add('hide');
        }
      }
    }, 500);
  },
  updateClubCheckoutCarrot: function(totalQuantity) {
    if (!document.body.contains(document.querySelector('.carrot-ctr.main-ctr.club-checkout .carrot-msg'))) return;

    let qty = totalQuantity;
    let carrotMain = document.querySelector('.carrot-ctr.club-checkout.main-ctr');
    let carrotMainMsg = document.querySelector('.carrot-ctr.main-ctr.club-checkout .carrot-msg');
    let carrotMainBtls = document.querySelectorAll('.carrot-ctr.main-ctr.club-checkout .bottle-ctr svg');

    // let carrotCartMsg = document.querySelector('.carrot-ctr.carrot-cart .carrot-msg');
    // let carrotCartBtls = document.querySelectorAll('.carrot-ctr.carrot-cart .bottle-ctr img');

    if (qty <= 0) {
      carrotMainMsg.innerText = 'Uncork 1 cent shipping with 6 bottles'; //'ONE CENT shipping on any 6+ bottles!'
    } else if (qty <= 5) {
      if (qty == 5) {
        carrotMainMsg.innerHTML = `You’re <strong>${6 - qty} bottle</strong> away from a shipping special!`;
      } else {
        carrotMainMsg.innerHTML = `You’re <strong>${6 - qty} bottles</strong> away from a shipping special!`;
      }
    } else {
      carrotMainMsg.innerText = `You’ve uncorked special shipping rates!`;
    }

    [...carrotMainBtls].forEach((element, index, array) => {
      let bottle = element;
      let fill = bottle.querySelector('.bottle-trans');

      if (index + 1 <= qty) {
        if (!bottle.classList.contains('fill')) {
          fill.classList.add('fill');
        }
      } else {
        fill.classList.remove('fill');
      }
    });
  },
  clubProfileCarrot: function() {
    //seen on checkout of club membership
    //http://rombauer-2021.local/profile/club-membership/e2b0d4d6-658f-414d-bde5-500db50160a2

    let clubCarrotMarkup = `
    <div class="carrot-ctr main-ctr profile-club-view">
    <p class="carrot-msg">Uncork 1 cent shipping with 6 bottles</p>
        <ul class="bottle-ctr">
              <li>
                <svg version="1.1" class="white_carrot_bottle" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 7.5 28.5" style="enable-background:new 0 0 7.5 28.5;" xml:space="preserve">
                <g id="_x35_">
                  <path class="bottle-trans" d="M5.2,7.2C5,6.9,4.9,2.2,4.9,0.7c0-0.1-0.1-0.2-0.2-0.3C4.6,0.3,4.5,0.3,4.4,0.3H3.1C3,0.3,2.8,0.3,2.8,0.4
                    C2.7,0.5,2.6,0.6,2.6,0.7c0,1.5-0.1,6.1-0.3,6.4c-0.6,1.1-2.1,1.5-2.1,4.4c0,2.9,0.1,13.3,0.1,14.4v0.9c0,0.4,0.2,0.7,0.4,1
                    c0.3,0.3,0.6,0.4,1,0.4h4c0.4,0,0.7-0.1,1-0.4c0.3-0.3,0.4-0.6,0.4-1V26c0-1,0.1-11.4,0.1-14.4C7.2,8.6,5.8,8.3,5.2,7.2z"></path>
                  <path class="bottle-stroke" d="M5.8,28.5h-4c-0.5,0-0.9-0.2-1.2-0.5c-0.3-0.3-0.5-0.7-0.5-1.1V26c0-0.4,0-2.1,0-4.2c0-3.6,0-8.3,0-10.2
                    c0-2.2,0.8-3,1.5-3.7C1.7,7.6,2,7.4,2.1,7.1c0.1-0.3,0.2-2.8,0.2-6.3c0-0.2,0.1-0.4,0.2-0.5C2.7,0.1,2.9,0,3.1,0h1.3
                    c0.2,0,0.4,0.1,0.5,0.2c0.1,0.1,0.2,0.3,0.2,0.5c0,3.6,0.1,6,0.2,6.3C5.5,7.4,5.8,7.6,6,7.9c0.7,0.7,1.5,1.5,1.5,3.7
                    c0,1.8,0,6.6,0,10.2c0,2.1,0,3.8,0,4.2v0.9c0,0.4-0.2,0.8-0.5,1.1C6.6,28.3,6.2,28.5,5.8,28.5z M3.1,0.5C3,0.5,3,0.5,2.9,0.6
                    c0,0-0.1,0.1-0.1,0.2C2.8,6.9,2.6,7.2,2.6,7.3C2.4,7.7,2.1,7.9,1.8,8.2c-0.6,0.7-1.3,1.4-1.3,3.4c0,1.8,0,6.6,0,10.2
                    c0,2.1,0,3.8,0,4.2v0.9c0,0.3,0.1,0.6,0.3,0.8C1.1,27.9,1.4,28,1.7,28h4c0.3,0,0.6-0.1,0.8-0.3c0.2-0.2,0.3-0.5,0.3-0.8V26
                    c0-0.4,0-2.1,0-4.2c0-3.6,0-8.3,0-10.2c0-2-0.7-2.7-1.3-3.4C5.4,7.9,5.1,7.7,4.9,7.3C4.9,7.2,4.7,6.9,4.6,0.7c0-0.1,0-0.1-0.1-0.2
                    c0,0-0.1-0.1-0.2-0.1H3.1z M5.4,7.1L5.4,7.1L5.4,7.1z"></path>
                </g>
                </svg>
              </li>
              <li>
              <svg version="1.1" class="white_carrot_bottle" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 7.5 28.5" style="enable-background:new 0 0 7.5 28.5;" xml:space="preserve">
              <g id="_x35_">
                <path class="bottle-trans" d="M5.2,7.2C5,6.9,4.9,2.2,4.9,0.7c0-0.1-0.1-0.2-0.2-0.3C4.6,0.3,4.5,0.3,4.4,0.3H3.1C3,0.3,2.8,0.3,2.8,0.4
                  C2.7,0.5,2.6,0.6,2.6,0.7c0,1.5-0.1,6.1-0.3,6.4c-0.6,1.1-2.1,1.5-2.1,4.4c0,2.9,0.1,13.3,0.1,14.4v0.9c0,0.4,0.2,0.7,0.4,1
                  c0.3,0.3,0.6,0.4,1,0.4h4c0.4,0,0.7-0.1,1-0.4c0.3-0.3,0.4-0.6,0.4-1V26c0-1,0.1-11.4,0.1-14.4C7.2,8.6,5.8,8.3,5.2,7.2z"></path>
                <path class="bottle-stroke" d="M5.8,28.5h-4c-0.5,0-0.9-0.2-1.2-0.5c-0.3-0.3-0.5-0.7-0.5-1.1V26c0-0.4,0-2.1,0-4.2c0-3.6,0-8.3,0-10.2
                  c0-2.2,0.8-3,1.5-3.7C1.7,7.6,2,7.4,2.1,7.1c0.1-0.3,0.2-2.8,0.2-6.3c0-0.2,0.1-0.4,0.2-0.5C2.7,0.1,2.9,0,3.1,0h1.3
                  c0.2,0,0.4,0.1,0.5,0.2c0.1,0.1,0.2,0.3,0.2,0.5c0,3.6,0.1,6,0.2,6.3C5.5,7.4,5.8,7.6,6,7.9c0.7,0.7,1.5,1.5,1.5,3.7
                  c0,1.8,0,6.6,0,10.2c0,2.1,0,3.8,0,4.2v0.9c0,0.4-0.2,0.8-0.5,1.1C6.6,28.3,6.2,28.5,5.8,28.5z M3.1,0.5C3,0.5,3,0.5,2.9,0.6
                  c0,0-0.1,0.1-0.1,0.2C2.8,6.9,2.6,7.2,2.6,7.3C2.4,7.7,2.1,7.9,1.8,8.2c-0.6,0.7-1.3,1.4-1.3,3.4c0,1.8,0,6.6,0,10.2
                  c0,2.1,0,3.8,0,4.2v0.9c0,0.3,0.1,0.6,0.3,0.8C1.1,27.9,1.4,28,1.7,28h4c0.3,0,0.6-0.1,0.8-0.3c0.2-0.2,0.3-0.5,0.3-0.8V26
                  c0-0.4,0-2.1,0-4.2c0-3.6,0-8.3,0-10.2c0-2-0.7-2.7-1.3-3.4C5.4,7.9,5.1,7.7,4.9,7.3C4.9,7.2,4.7,6.9,4.6,0.7c0-0.1,0-0.1-0.1-0.2
                  c0,0-0.1-0.1-0.2-0.1H3.1z M5.4,7.1L5.4,7.1L5.4,7.1z"></path>
              </g>
              </svg>
            </li>
            <li>
            <svg version="1.1" class="white_carrot_bottle" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 7.5 28.5" style="enable-background:new 0 0 7.5 28.5;" xml:space="preserve">
            <g id="_x35_">
              <path class="bottle-trans" d="M5.2,7.2C5,6.9,4.9,2.2,4.9,0.7c0-0.1-0.1-0.2-0.2-0.3C4.6,0.3,4.5,0.3,4.4,0.3H3.1C3,0.3,2.8,0.3,2.8,0.4
                C2.7,0.5,2.6,0.6,2.6,0.7c0,1.5-0.1,6.1-0.3,6.4c-0.6,1.1-2.1,1.5-2.1,4.4c0,2.9,0.1,13.3,0.1,14.4v0.9c0,0.4,0.2,0.7,0.4,1
                c0.3,0.3,0.6,0.4,1,0.4h4c0.4,0,0.7-0.1,1-0.4c0.3-0.3,0.4-0.6,0.4-1V26c0-1,0.1-11.4,0.1-14.4C7.2,8.6,5.8,8.3,5.2,7.2z"></path>
              <path class="bottle-stroke" d="M5.8,28.5h-4c-0.5,0-0.9-0.2-1.2-0.5c-0.3-0.3-0.5-0.7-0.5-1.1V26c0-0.4,0-2.1,0-4.2c0-3.6,0-8.3,0-10.2
                c0-2.2,0.8-3,1.5-3.7C1.7,7.6,2,7.4,2.1,7.1c0.1-0.3,0.2-2.8,0.2-6.3c0-0.2,0.1-0.4,0.2-0.5C2.7,0.1,2.9,0,3.1,0h1.3
                c0.2,0,0.4,0.1,0.5,0.2c0.1,0.1,0.2,0.3,0.2,0.5c0,3.6,0.1,6,0.2,6.3C5.5,7.4,5.8,7.6,6,7.9c0.7,0.7,1.5,1.5,1.5,3.7
                c0,1.8,0,6.6,0,10.2c0,2.1,0,3.8,0,4.2v0.9c0,0.4-0.2,0.8-0.5,1.1C6.6,28.3,6.2,28.5,5.8,28.5z M3.1,0.5C3,0.5,3,0.5,2.9,0.6
                c0,0-0.1,0.1-0.1,0.2C2.8,6.9,2.6,7.2,2.6,7.3C2.4,7.7,2.1,7.9,1.8,8.2c-0.6,0.7-1.3,1.4-1.3,3.4c0,1.8,0,6.6,0,10.2
                c0,2.1,0,3.8,0,4.2v0.9c0,0.3,0.1,0.6,0.3,0.8C1.1,27.9,1.4,28,1.7,28h4c0.3,0,0.6-0.1,0.8-0.3c0.2-0.2,0.3-0.5,0.3-0.8V26
                c0-0.4,0-2.1,0-4.2c0-3.6,0-8.3,0-10.2c0-2-0.7-2.7-1.3-3.4C5.4,7.9,5.1,7.7,4.9,7.3C4.9,7.2,4.7,6.9,4.6,0.7c0-0.1,0-0.1-0.1-0.2
                c0,0-0.1-0.1-0.2-0.1H3.1z M5.4,7.1L5.4,7.1L5.4,7.1z"></path>
            </g>
            </svg>
          </li>
          <li>
          <svg version="1.1" class="white_carrot_bottle" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 7.5 28.5" style="enable-background:new 0 0 7.5 28.5;" xml:space="preserve">
          <g id="_x35_">
            <path class="bottle-trans" d="M5.2,7.2C5,6.9,4.9,2.2,4.9,0.7c0-0.1-0.1-0.2-0.2-0.3C4.6,0.3,4.5,0.3,4.4,0.3H3.1C3,0.3,2.8,0.3,2.8,0.4
              C2.7,0.5,2.6,0.6,2.6,0.7c0,1.5-0.1,6.1-0.3,6.4c-0.6,1.1-2.1,1.5-2.1,4.4c0,2.9,0.1,13.3,0.1,14.4v0.9c0,0.4,0.2,0.7,0.4,1
              c0.3,0.3,0.6,0.4,1,0.4h4c0.4,0,0.7-0.1,1-0.4c0.3-0.3,0.4-0.6,0.4-1V26c0-1,0.1-11.4,0.1-14.4C7.2,8.6,5.8,8.3,5.2,7.2z"></path>
            <path class="bottle-stroke" d="M5.8,28.5h-4c-0.5,0-0.9-0.2-1.2-0.5c-0.3-0.3-0.5-0.7-0.5-1.1V26c0-0.4,0-2.1,0-4.2c0-3.6,0-8.3,0-10.2
              c0-2.2,0.8-3,1.5-3.7C1.7,7.6,2,7.4,2.1,7.1c0.1-0.3,0.2-2.8,0.2-6.3c0-0.2,0.1-0.4,0.2-0.5C2.7,0.1,2.9,0,3.1,0h1.3
              c0.2,0,0.4,0.1,0.5,0.2c0.1,0.1,0.2,0.3,0.2,0.5c0,3.6,0.1,6,0.2,6.3C5.5,7.4,5.8,7.6,6,7.9c0.7,0.7,1.5,1.5,1.5,3.7
              c0,1.8,0,6.6,0,10.2c0,2.1,0,3.8,0,4.2v0.9c0,0.4-0.2,0.8-0.5,1.1C6.6,28.3,6.2,28.5,5.8,28.5z M3.1,0.5C3,0.5,3,0.5,2.9,0.6
              c0,0-0.1,0.1-0.1,0.2C2.8,6.9,2.6,7.2,2.6,7.3C2.4,7.7,2.1,7.9,1.8,8.2c-0.6,0.7-1.3,1.4-1.3,3.4c0,1.8,0,6.6,0,10.2
              c0,2.1,0,3.8,0,4.2v0.9c0,0.3,0.1,0.6,0.3,0.8C1.1,27.9,1.4,28,1.7,28h4c0.3,0,0.6-0.1,0.8-0.3c0.2-0.2,0.3-0.5,0.3-0.8V26
              c0-0.4,0-2.1,0-4.2c0-3.6,0-8.3,0-10.2c0-2-0.7-2.7-1.3-3.4C5.4,7.9,5.1,7.7,4.9,7.3C4.9,7.2,4.7,6.9,4.6,0.7c0-0.1,0-0.1-0.1-0.2
              c0,0-0.1-0.1-0.2-0.1H3.1z M5.4,7.1L5.4,7.1L5.4,7.1z"></path>
          </g>
          </svg>
        </li>
        <li>
        <svg version="1.1" class="white_carrot_bottle" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 7.5 28.5" style="enable-background:new 0 0 7.5 28.5;" xml:space="preserve">
        <g id="_x35_">
          <path class="bottle-trans" d="M5.2,7.2C5,6.9,4.9,2.2,4.9,0.7c0-0.1-0.1-0.2-0.2-0.3C4.6,0.3,4.5,0.3,4.4,0.3H3.1C3,0.3,2.8,0.3,2.8,0.4
            C2.7,0.5,2.6,0.6,2.6,0.7c0,1.5-0.1,6.1-0.3,6.4c-0.6,1.1-2.1,1.5-2.1,4.4c0,2.9,0.1,13.3,0.1,14.4v0.9c0,0.4,0.2,0.7,0.4,1
            c0.3,0.3,0.6,0.4,1,0.4h4c0.4,0,0.7-0.1,1-0.4c0.3-0.3,0.4-0.6,0.4-1V26c0-1,0.1-11.4,0.1-14.4C7.2,8.6,5.8,8.3,5.2,7.2z"></path>
          <path class="bottle-stroke" d="M5.8,28.5h-4c-0.5,0-0.9-0.2-1.2-0.5c-0.3-0.3-0.5-0.7-0.5-1.1V26c0-0.4,0-2.1,0-4.2c0-3.6,0-8.3,0-10.2
            c0-2.2,0.8-3,1.5-3.7C1.7,7.6,2,7.4,2.1,7.1c0.1-0.3,0.2-2.8,0.2-6.3c0-0.2,0.1-0.4,0.2-0.5C2.7,0.1,2.9,0,3.1,0h1.3
            c0.2,0,0.4,0.1,0.5,0.2c0.1,0.1,0.2,0.3,0.2,0.5c0,3.6,0.1,6,0.2,6.3C5.5,7.4,5.8,7.6,6,7.9c0.7,0.7,1.5,1.5,1.5,3.7
            c0,1.8,0,6.6,0,10.2c0,2.1,0,3.8,0,4.2v0.9c0,0.4-0.2,0.8-0.5,1.1C6.6,28.3,6.2,28.5,5.8,28.5z M3.1,0.5C3,0.5,3,0.5,2.9,0.6
            c0,0-0.1,0.1-0.1,0.2C2.8,6.9,2.6,7.2,2.6,7.3C2.4,7.7,2.1,7.9,1.8,8.2c-0.6,0.7-1.3,1.4-1.3,3.4c0,1.8,0,6.6,0,10.2
            c0,2.1,0,3.8,0,4.2v0.9c0,0.3,0.1,0.6,0.3,0.8C1.1,27.9,1.4,28,1.7,28h4c0.3,0,0.6-0.1,0.8-0.3c0.2-0.2,0.3-0.5,0.3-0.8V26
            c0-0.4,0-2.1,0-4.2c0-3.6,0-8.3,0-10.2c0-2-0.7-2.7-1.3-3.4C5.4,7.9,5.1,7.7,4.9,7.3C4.9,7.2,4.7,6.9,4.6,0.7c0-0.1,0-0.1-0.1-0.2
            c0,0-0.1-0.1-0.2-0.1H3.1z M5.4,7.1L5.4,7.1L5.4,7.1z"></path>
        </g>
        </svg>
      </li>
      <li>
      <svg version="1.1" class="white_carrot_bottle" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 7.5 28.5" style="enable-background:new 0 0 7.5 28.5;" xml:space="preserve">
      <g id="_x35_">
        <path class="bottle-trans" d="M5.2,7.2C5,6.9,4.9,2.2,4.9,0.7c0-0.1-0.1-0.2-0.2-0.3C4.6,0.3,4.5,0.3,4.4,0.3H3.1C3,0.3,2.8,0.3,2.8,0.4
          C2.7,0.5,2.6,0.6,2.6,0.7c0,1.5-0.1,6.1-0.3,6.4c-0.6,1.1-2.1,1.5-2.1,4.4c0,2.9,0.1,13.3,0.1,14.4v0.9c0,0.4,0.2,0.7,0.4,1
          c0.3,0.3,0.6,0.4,1,0.4h4c0.4,0,0.7-0.1,1-0.4c0.3-0.3,0.4-0.6,0.4-1V26c0-1,0.1-11.4,0.1-14.4C7.2,8.6,5.8,8.3,5.2,7.2z"></path>
        <path class="bottle-stroke" d="M5.8,28.5h-4c-0.5,0-0.9-0.2-1.2-0.5c-0.3-0.3-0.5-0.7-0.5-1.1V26c0-0.4,0-2.1,0-4.2c0-3.6,0-8.3,0-10.2
          c0-2.2,0.8-3,1.5-3.7C1.7,7.6,2,7.4,2.1,7.1c0.1-0.3,0.2-2.8,0.2-6.3c0-0.2,0.1-0.4,0.2-0.5C2.7,0.1,2.9,0,3.1,0h1.3
          c0.2,0,0.4,0.1,0.5,0.2c0.1,0.1,0.2,0.3,0.2,0.5c0,3.6,0.1,6,0.2,6.3C5.5,7.4,5.8,7.6,6,7.9c0.7,0.7,1.5,1.5,1.5,3.7
          c0,1.8,0,6.6,0,10.2c0,2.1,0,3.8,0,4.2v0.9c0,0.4-0.2,0.8-0.5,1.1C6.6,28.3,6.2,28.5,5.8,28.5z M3.1,0.5C3,0.5,3,0.5,2.9,0.6
          c0,0-0.1,0.1-0.1,0.2C2.8,6.9,2.6,7.2,2.6,7.3C2.4,7.7,2.1,7.9,1.8,8.2c-0.6,0.7-1.3,1.4-1.3,3.4c0,1.8,0,6.6,0,10.2
          c0,2.1,0,3.8,0,4.2v0.9c0,0.3,0.1,0.6,0.3,0.8C1.1,27.9,1.4,28,1.7,28h4c0.3,0,0.6-0.1,0.8-0.3c0.2-0.2,0.3-0.5,0.3-0.8V26
          c0-0.4,0-2.1,0-4.2c0-3.6,0-8.3,0-10.2c0-2-0.7-2.7-1.3-3.4C5.4,7.9,5.1,7.7,4.9,7.3C4.9,7.2,4.7,6.9,4.6,0.7c0-0.1,0-0.1-0.1-0.2
          c0,0-0.1-0.1-0.2-0.1H3.1z M5.4,7.1L5.4,7.1L5.4,7.1z"></path>
      </g>
      </svg>
      </li>


        </ul>

    </div>	
    `;

    let clubAccountCarrotList = [];
    let clubId = 0;

    let intervalId = setInterval(function() {
      let url = new URL(window.location);

      if (
        url.pathname.includes('/profile/club-membership') &&
        document.body.contains(document.querySelector('.c7-account-club-shipments')) &&
        document.body.contains(document.querySelector('.c7-order-items--shipment')) &&
        document.body.contains(document.querySelector('.c7-account__header'))
      ) {
        let clubAccount = document.querySelectorAll('.c7-account-club');

        [...clubAccount].forEach((club) => {
          if (club.classList.contains('has-carrot')) return;
          if (club.querySelector('.c7-order-items--shipment')) {
            let header = club.querySelector('.c7-account-club__header');
            header.insertAdjacentHTML('afterend', clubCarrotMarkup);
            club.classList.add('has-carrot');
            club.clubId = 'club-' + clubId++;
            let clubCarrot = new ClubCarrotClass(club.clubId);
            clubAccountCarrotList.push(clubCarrot);
          }
        });

        let clubAccountCarrot = document.querySelectorAll('.c7-account-club.has-carrot');

        [...clubAccountCarrot].forEach((club) => {
          let totalQuantity = 0;

          let clubItems = club.querySelectorAll('.c7-order-items--shipment .c7-order-item');

          [...clubItems].forEach((item) => {
            let numberArray = item.querySelector('.c7-order-item__pricing .c7-order-item__quantity').innerHTML.match(/\d+/g);
            let quantity = numberArray[1];
            totalQuantity += parseInt(quantity);
          });

          //    console.log('clubAccountCarrotList', clubAccountCarrotList);

          let clubCarrot = clubAccountCarrotList.find((c) => c.id === club.clubId);
          if (clubCarrot.updateTotalQuantity(totalQuantity)) {
            Carrot.updateClubProfileCarrot(club, totalQuantity);
          }
        });
      }
    }, 500);
  },
  updateClubProfileCarrot: function(club, totalQuantity) {
    //if (!document.body.contains(club.querySelector('.carrot-ctr.main-ctr.profile-club-view .carrot-msg'))) return;

    let qty = totalQuantity;
    let carrotMain = club.querySelector('.carrot-ctr.profile-club-view.main-ctr');
    let carrotMainMsg = club.querySelector('.carrot-ctr.main-ctr.profile-club-view .carrot-msg');
    let carrotMainBtls = club.querySelectorAll('.carrot-ctr.main-ctr.profile-club-view .bottle-ctr svg');

    // let carrotCartMsg = document.querySelector('.carrot-ctr.carrot-cart .carrot-msg');
    // let carrotCartBtls = document.querySelectorAll('.carrot-ctr.carrot-cart .bottle-ctr img');

    if (qty <= 0) {
      carrotMainMsg.innerText = 'Uncork 1 cent shipping with 6 bottles'; //'ONE CENT shipping on any 6+ bottles!'
    } else if (qty <= 5) {
      if (qty == 5) {
        carrotMainMsg.innerHTML = `You’re <strong>${6 - qty} bottle</strong> away from a shipping special!`;
      } else {
        carrotMainMsg.innerHTML = `You’re <strong>${6 - qty} bottles</strong> away from a shipping special!`;
      }
    } else {
      carrotMainMsg.innerText = `You’ve uncorked special shipping rates!`;
    }

    console.log('carrotMainMsg.innerText', carrotMainMsg.innerText);

    [...carrotMainBtls].forEach((element, index, array) => {
      let bottle = element;
      let fill = bottle.querySelector('.bottle-trans');

      if (index + 1 <= qty) {
        if (!bottle.classList.contains('fill')) {
          fill.classList.add('fill');
        }
      } else {
        fill.classList.remove('fill');
      }
    });
  },
  clubModalCarrot: function() {
    //seen on checkout of club membership profile page edit wines

    let clubCarrotMarkup = `
    <div class="carrot-ctr main-ctr club-modal-carrot">
    <p class="carrot-msg">Uncork 1 cent shipping with 6 bottles</p>
        <ul class="bottle-ctr">
              <li>
                <svg version="1.1" class="white_carrot_bottle" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 7.5 28.5" style="enable-background:new 0 0 7.5 28.5;" xml:space="preserve">
                <g id="_x35_">
                  <path class="bottle-trans" d="M5.2,7.2C5,6.9,4.9,2.2,4.9,0.7c0-0.1-0.1-0.2-0.2-0.3C4.6,0.3,4.5,0.3,4.4,0.3H3.1C3,0.3,2.8,0.3,2.8,0.4
                    C2.7,0.5,2.6,0.6,2.6,0.7c0,1.5-0.1,6.1-0.3,6.4c-0.6,1.1-2.1,1.5-2.1,4.4c0,2.9,0.1,13.3,0.1,14.4v0.9c0,0.4,0.2,0.7,0.4,1
                    c0.3,0.3,0.6,0.4,1,0.4h4c0.4,0,0.7-0.1,1-0.4c0.3-0.3,0.4-0.6,0.4-1V26c0-1,0.1-11.4,0.1-14.4C7.2,8.6,5.8,8.3,5.2,7.2z"></path>
                  <path class="bottle-stroke" d="M5.8,28.5h-4c-0.5,0-0.9-0.2-1.2-0.5c-0.3-0.3-0.5-0.7-0.5-1.1V26c0-0.4,0-2.1,0-4.2c0-3.6,0-8.3,0-10.2
                    c0-2.2,0.8-3,1.5-3.7C1.7,7.6,2,7.4,2.1,7.1c0.1-0.3,0.2-2.8,0.2-6.3c0-0.2,0.1-0.4,0.2-0.5C2.7,0.1,2.9,0,3.1,0h1.3
                    c0.2,0,0.4,0.1,0.5,0.2c0.1,0.1,0.2,0.3,0.2,0.5c0,3.6,0.1,6,0.2,6.3C5.5,7.4,5.8,7.6,6,7.9c0.7,0.7,1.5,1.5,1.5,3.7
                    c0,1.8,0,6.6,0,10.2c0,2.1,0,3.8,0,4.2v0.9c0,0.4-0.2,0.8-0.5,1.1C6.6,28.3,6.2,28.5,5.8,28.5z M3.1,0.5C3,0.5,3,0.5,2.9,0.6
                    c0,0-0.1,0.1-0.1,0.2C2.8,6.9,2.6,7.2,2.6,7.3C2.4,7.7,2.1,7.9,1.8,8.2c-0.6,0.7-1.3,1.4-1.3,3.4c0,1.8,0,6.6,0,10.2
                    c0,2.1,0,3.8,0,4.2v0.9c0,0.3,0.1,0.6,0.3,0.8C1.1,27.9,1.4,28,1.7,28h4c0.3,0,0.6-0.1,0.8-0.3c0.2-0.2,0.3-0.5,0.3-0.8V26
                    c0-0.4,0-2.1,0-4.2c0-3.6,0-8.3,0-10.2c0-2-0.7-2.7-1.3-3.4C5.4,7.9,5.1,7.7,4.9,7.3C4.9,7.2,4.7,6.9,4.6,0.7c0-0.1,0-0.1-0.1-0.2
                    c0,0-0.1-0.1-0.2-0.1H3.1z M5.4,7.1L5.4,7.1L5.4,7.1z"></path>
                </g>
                </svg>
              </li>
              <li>
              <svg version="1.1" class="white_carrot_bottle" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 7.5 28.5" style="enable-background:new 0 0 7.5 28.5;" xml:space="preserve">
              <g id="_x35_">
                <path class="bottle-trans" d="M5.2,7.2C5,6.9,4.9,2.2,4.9,0.7c0-0.1-0.1-0.2-0.2-0.3C4.6,0.3,4.5,0.3,4.4,0.3H3.1C3,0.3,2.8,0.3,2.8,0.4
                  C2.7,0.5,2.6,0.6,2.6,0.7c0,1.5-0.1,6.1-0.3,6.4c-0.6,1.1-2.1,1.5-2.1,4.4c0,2.9,0.1,13.3,0.1,14.4v0.9c0,0.4,0.2,0.7,0.4,1
                  c0.3,0.3,0.6,0.4,1,0.4h4c0.4,0,0.7-0.1,1-0.4c0.3-0.3,0.4-0.6,0.4-1V26c0-1,0.1-11.4,0.1-14.4C7.2,8.6,5.8,8.3,5.2,7.2z"></path>
                <path class="bottle-stroke" d="M5.8,28.5h-4c-0.5,0-0.9-0.2-1.2-0.5c-0.3-0.3-0.5-0.7-0.5-1.1V26c0-0.4,0-2.1,0-4.2c0-3.6,0-8.3,0-10.2
                  c0-2.2,0.8-3,1.5-3.7C1.7,7.6,2,7.4,2.1,7.1c0.1-0.3,0.2-2.8,0.2-6.3c0-0.2,0.1-0.4,0.2-0.5C2.7,0.1,2.9,0,3.1,0h1.3
                  c0.2,0,0.4,0.1,0.5,0.2c0.1,0.1,0.2,0.3,0.2,0.5c0,3.6,0.1,6,0.2,6.3C5.5,7.4,5.8,7.6,6,7.9c0.7,0.7,1.5,1.5,1.5,3.7
                  c0,1.8,0,6.6,0,10.2c0,2.1,0,3.8,0,4.2v0.9c0,0.4-0.2,0.8-0.5,1.1C6.6,28.3,6.2,28.5,5.8,28.5z M3.1,0.5C3,0.5,3,0.5,2.9,0.6
                  c0,0-0.1,0.1-0.1,0.2C2.8,6.9,2.6,7.2,2.6,7.3C2.4,7.7,2.1,7.9,1.8,8.2c-0.6,0.7-1.3,1.4-1.3,3.4c0,1.8,0,6.6,0,10.2
                  c0,2.1,0,3.8,0,4.2v0.9c0,0.3,0.1,0.6,0.3,0.8C1.1,27.9,1.4,28,1.7,28h4c0.3,0,0.6-0.1,0.8-0.3c0.2-0.2,0.3-0.5,0.3-0.8V26
                  c0-0.4,0-2.1,0-4.2c0-3.6,0-8.3,0-10.2c0-2-0.7-2.7-1.3-3.4C5.4,7.9,5.1,7.7,4.9,7.3C4.9,7.2,4.7,6.9,4.6,0.7c0-0.1,0-0.1-0.1-0.2
                  c0,0-0.1-0.1-0.2-0.1H3.1z M5.4,7.1L5.4,7.1L5.4,7.1z"></path>
              </g>
              </svg>
            </li>
            <li>
            <svg version="1.1" class="white_carrot_bottle" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 7.5 28.5" style="enable-background:new 0 0 7.5 28.5;" xml:space="preserve">
            <g id="_x35_">
              <path class="bottle-trans" d="M5.2,7.2C5,6.9,4.9,2.2,4.9,0.7c0-0.1-0.1-0.2-0.2-0.3C4.6,0.3,4.5,0.3,4.4,0.3H3.1C3,0.3,2.8,0.3,2.8,0.4
                C2.7,0.5,2.6,0.6,2.6,0.7c0,1.5-0.1,6.1-0.3,6.4c-0.6,1.1-2.1,1.5-2.1,4.4c0,2.9,0.1,13.3,0.1,14.4v0.9c0,0.4,0.2,0.7,0.4,1
                c0.3,0.3,0.6,0.4,1,0.4h4c0.4,0,0.7-0.1,1-0.4c0.3-0.3,0.4-0.6,0.4-1V26c0-1,0.1-11.4,0.1-14.4C7.2,8.6,5.8,8.3,5.2,7.2z"></path>
              <path class="bottle-stroke" d="M5.8,28.5h-4c-0.5,0-0.9-0.2-1.2-0.5c-0.3-0.3-0.5-0.7-0.5-1.1V26c0-0.4,0-2.1,0-4.2c0-3.6,0-8.3,0-10.2
                c0-2.2,0.8-3,1.5-3.7C1.7,7.6,2,7.4,2.1,7.1c0.1-0.3,0.2-2.8,0.2-6.3c0-0.2,0.1-0.4,0.2-0.5C2.7,0.1,2.9,0,3.1,0h1.3
                c0.2,0,0.4,0.1,0.5,0.2c0.1,0.1,0.2,0.3,0.2,0.5c0,3.6,0.1,6,0.2,6.3C5.5,7.4,5.8,7.6,6,7.9c0.7,0.7,1.5,1.5,1.5,3.7
                c0,1.8,0,6.6,0,10.2c0,2.1,0,3.8,0,4.2v0.9c0,0.4-0.2,0.8-0.5,1.1C6.6,28.3,6.2,28.5,5.8,28.5z M3.1,0.5C3,0.5,3,0.5,2.9,0.6
                c0,0-0.1,0.1-0.1,0.2C2.8,6.9,2.6,7.2,2.6,7.3C2.4,7.7,2.1,7.9,1.8,8.2c-0.6,0.7-1.3,1.4-1.3,3.4c0,1.8,0,6.6,0,10.2
                c0,2.1,0,3.8,0,4.2v0.9c0,0.3,0.1,0.6,0.3,0.8C1.1,27.9,1.4,28,1.7,28h4c0.3,0,0.6-0.1,0.8-0.3c0.2-0.2,0.3-0.5,0.3-0.8V26
                c0-0.4,0-2.1,0-4.2c0-3.6,0-8.3,0-10.2c0-2-0.7-2.7-1.3-3.4C5.4,7.9,5.1,7.7,4.9,7.3C4.9,7.2,4.7,6.9,4.6,0.7c0-0.1,0-0.1-0.1-0.2
                c0,0-0.1-0.1-0.2-0.1H3.1z M5.4,7.1L5.4,7.1L5.4,7.1z"></path>
            </g>
            </svg>
          </li>
          <li>
          <svg version="1.1" class="white_carrot_bottle" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 7.5 28.5" style="enable-background:new 0 0 7.5 28.5;" xml:space="preserve">
          <g id="_x35_">
            <path class="bottle-trans" d="M5.2,7.2C5,6.9,4.9,2.2,4.9,0.7c0-0.1-0.1-0.2-0.2-0.3C4.6,0.3,4.5,0.3,4.4,0.3H3.1C3,0.3,2.8,0.3,2.8,0.4
              C2.7,0.5,2.6,0.6,2.6,0.7c0,1.5-0.1,6.1-0.3,6.4c-0.6,1.1-2.1,1.5-2.1,4.4c0,2.9,0.1,13.3,0.1,14.4v0.9c0,0.4,0.2,0.7,0.4,1
              c0.3,0.3,0.6,0.4,1,0.4h4c0.4,0,0.7-0.1,1-0.4c0.3-0.3,0.4-0.6,0.4-1V26c0-1,0.1-11.4,0.1-14.4C7.2,8.6,5.8,8.3,5.2,7.2z"></path>
            <path class="bottle-stroke" d="M5.8,28.5h-4c-0.5,0-0.9-0.2-1.2-0.5c-0.3-0.3-0.5-0.7-0.5-1.1V26c0-0.4,0-2.1,0-4.2c0-3.6,0-8.3,0-10.2
              c0-2.2,0.8-3,1.5-3.7C1.7,7.6,2,7.4,2.1,7.1c0.1-0.3,0.2-2.8,0.2-6.3c0-0.2,0.1-0.4,0.2-0.5C2.7,0.1,2.9,0,3.1,0h1.3
              c0.2,0,0.4,0.1,0.5,0.2c0.1,0.1,0.2,0.3,0.2,0.5c0,3.6,0.1,6,0.2,6.3C5.5,7.4,5.8,7.6,6,7.9c0.7,0.7,1.5,1.5,1.5,3.7
              c0,1.8,0,6.6,0,10.2c0,2.1,0,3.8,0,4.2v0.9c0,0.4-0.2,0.8-0.5,1.1C6.6,28.3,6.2,28.5,5.8,28.5z M3.1,0.5C3,0.5,3,0.5,2.9,0.6
              c0,0-0.1,0.1-0.1,0.2C2.8,6.9,2.6,7.2,2.6,7.3C2.4,7.7,2.1,7.9,1.8,8.2c-0.6,0.7-1.3,1.4-1.3,3.4c0,1.8,0,6.6,0,10.2
              c0,2.1,0,3.8,0,4.2v0.9c0,0.3,0.1,0.6,0.3,0.8C1.1,27.9,1.4,28,1.7,28h4c0.3,0,0.6-0.1,0.8-0.3c0.2-0.2,0.3-0.5,0.3-0.8V26
              c0-0.4,0-2.1,0-4.2c0-3.6,0-8.3,0-10.2c0-2-0.7-2.7-1.3-3.4C5.4,7.9,5.1,7.7,4.9,7.3C4.9,7.2,4.7,6.9,4.6,0.7c0-0.1,0-0.1-0.1-0.2
              c0,0-0.1-0.1-0.2-0.1H3.1z M5.4,7.1L5.4,7.1L5.4,7.1z"></path>
          </g>
          </svg>
        </li>
        <li>
        <svg version="1.1" class="white_carrot_bottle" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 7.5 28.5" style="enable-background:new 0 0 7.5 28.5;" xml:space="preserve">
        <g id="_x35_">
          <path class="bottle-trans" d="M5.2,7.2C5,6.9,4.9,2.2,4.9,0.7c0-0.1-0.1-0.2-0.2-0.3C4.6,0.3,4.5,0.3,4.4,0.3H3.1C3,0.3,2.8,0.3,2.8,0.4
            C2.7,0.5,2.6,0.6,2.6,0.7c0,1.5-0.1,6.1-0.3,6.4c-0.6,1.1-2.1,1.5-2.1,4.4c0,2.9,0.1,13.3,0.1,14.4v0.9c0,0.4,0.2,0.7,0.4,1
            c0.3,0.3,0.6,0.4,1,0.4h4c0.4,0,0.7-0.1,1-0.4c0.3-0.3,0.4-0.6,0.4-1V26c0-1,0.1-11.4,0.1-14.4C7.2,8.6,5.8,8.3,5.2,7.2z"></path>
          <path class="bottle-stroke" d="M5.8,28.5h-4c-0.5,0-0.9-0.2-1.2-0.5c-0.3-0.3-0.5-0.7-0.5-1.1V26c0-0.4,0-2.1,0-4.2c0-3.6,0-8.3,0-10.2
            c0-2.2,0.8-3,1.5-3.7C1.7,7.6,2,7.4,2.1,7.1c0.1-0.3,0.2-2.8,0.2-6.3c0-0.2,0.1-0.4,0.2-0.5C2.7,0.1,2.9,0,3.1,0h1.3
            c0.2,0,0.4,0.1,0.5,0.2c0.1,0.1,0.2,0.3,0.2,0.5c0,3.6,0.1,6,0.2,6.3C5.5,7.4,5.8,7.6,6,7.9c0.7,0.7,1.5,1.5,1.5,3.7
            c0,1.8,0,6.6,0,10.2c0,2.1,0,3.8,0,4.2v0.9c0,0.4-0.2,0.8-0.5,1.1C6.6,28.3,6.2,28.5,5.8,28.5z M3.1,0.5C3,0.5,3,0.5,2.9,0.6
            c0,0-0.1,0.1-0.1,0.2C2.8,6.9,2.6,7.2,2.6,7.3C2.4,7.7,2.1,7.9,1.8,8.2c-0.6,0.7-1.3,1.4-1.3,3.4c0,1.8,0,6.6,0,10.2
            c0,2.1,0,3.8,0,4.2v0.9c0,0.3,0.1,0.6,0.3,0.8C1.1,27.9,1.4,28,1.7,28h4c0.3,0,0.6-0.1,0.8-0.3c0.2-0.2,0.3-0.5,0.3-0.8V26
            c0-0.4,0-2.1,0-4.2c0-3.6,0-8.3,0-10.2c0-2-0.7-2.7-1.3-3.4C5.4,7.9,5.1,7.7,4.9,7.3C4.9,7.2,4.7,6.9,4.6,0.7c0-0.1,0-0.1-0.1-0.2
            c0,0-0.1-0.1-0.2-0.1H3.1z M5.4,7.1L5.4,7.1L5.4,7.1z"></path>
        </g>
        </svg>
      </li>
      <li>
      <svg version="1.1" class="white_carrot_bottle" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 7.5 28.5" style="enable-background:new 0 0 7.5 28.5;" xml:space="preserve">
      <g id="_x35_">
        <path class="bottle-trans" d="M5.2,7.2C5,6.9,4.9,2.2,4.9,0.7c0-0.1-0.1-0.2-0.2-0.3C4.6,0.3,4.5,0.3,4.4,0.3H3.1C3,0.3,2.8,0.3,2.8,0.4
          C2.7,0.5,2.6,0.6,2.6,0.7c0,1.5-0.1,6.1-0.3,6.4c-0.6,1.1-2.1,1.5-2.1,4.4c0,2.9,0.1,13.3,0.1,14.4v0.9c0,0.4,0.2,0.7,0.4,1
          c0.3,0.3,0.6,0.4,1,0.4h4c0.4,0,0.7-0.1,1-0.4c0.3-0.3,0.4-0.6,0.4-1V26c0-1,0.1-11.4,0.1-14.4C7.2,8.6,5.8,8.3,5.2,7.2z"></path>
        <path class="bottle-stroke" d="M5.8,28.5h-4c-0.5,0-0.9-0.2-1.2-0.5c-0.3-0.3-0.5-0.7-0.5-1.1V26c0-0.4,0-2.1,0-4.2c0-3.6,0-8.3,0-10.2
          c0-2.2,0.8-3,1.5-3.7C1.7,7.6,2,7.4,2.1,7.1c0.1-0.3,0.2-2.8,0.2-6.3c0-0.2,0.1-0.4,0.2-0.5C2.7,0.1,2.9,0,3.1,0h1.3
          c0.2,0,0.4,0.1,0.5,0.2c0.1,0.1,0.2,0.3,0.2,0.5c0,3.6,0.1,6,0.2,6.3C5.5,7.4,5.8,7.6,6,7.9c0.7,0.7,1.5,1.5,1.5,3.7
          c0,1.8,0,6.6,0,10.2c0,2.1,0,3.8,0,4.2v0.9c0,0.4-0.2,0.8-0.5,1.1C6.6,28.3,6.2,28.5,5.8,28.5z M3.1,0.5C3,0.5,3,0.5,2.9,0.6
          c0,0-0.1,0.1-0.1,0.2C2.8,6.9,2.6,7.2,2.6,7.3C2.4,7.7,2.1,7.9,1.8,8.2c-0.6,0.7-1.3,1.4-1.3,3.4c0,1.8,0,6.6,0,10.2
          c0,2.1,0,3.8,0,4.2v0.9c0,0.3,0.1,0.6,0.3,0.8C1.1,27.9,1.4,28,1.7,28h4c0.3,0,0.6-0.1,0.8-0.3c0.2-0.2,0.3-0.5,0.3-0.8V26
          c0-0.4,0-2.1,0-4.2c0-3.6,0-8.3,0-10.2c0-2-0.7-2.7-1.3-3.4C5.4,7.9,5.1,7.7,4.9,7.3C4.9,7.2,4.7,6.9,4.6,0.7c0-0.1,0-0.1-0.1-0.2
          c0,0-0.1-0.1-0.2-0.1H3.1z M5.4,7.1L5.4,7.1L5.4,7.1z"></path>
      </g>
      </svg>
      </li>


        </ul>

    </div>	
    `;

    let intervalId = setInterval(function() {
      let url = new URL(window.location);

      if (url.pathname.includes('/profile/club-membership') && document.body.contains(document.querySelector('.c7-modal-container.c7-account-club-shipment'))) {
        let header = document.querySelector('.c7-modal-container.c7-account-club-shipment .c7-account-club-shipment__header');
        //place clubcarrotMarkup after header
        if (header && !document.querySelector('.carrot-ctr.club-modal-carrot')) {
          header.insertAdjacentHTML('beforeend', clubCarrotMarkup);
        }

        let totalQuantity = document.querySelectorAll('.c7-modal-container.c7-account-club-shipment .c7-account-club-shipment__selected-products .c7-order-item:not(.c7-order-item--empty)').length;

        Carrot.updateClubModalCarrot(totalQuantity);
      }
    }, 500);
  },
  updateClubModalCarrot: function(totalQuantity) {
    if (!document.body.contains(document.querySelector('.carrot-ctr.main-ctr.club-modal-carrot .carrot-msg'))) return;

    let qty = totalQuantity;
    let carrotMain = document.querySelector('.carrot-ctr.club-modal-carrot.main-ctr');
    let carrotMainMsg = document.querySelector('.carrot-ctr.main-ctr.club-modal-carrot .carrot-msg');
    let carrotMainBtls = document.querySelectorAll('.carrot-ctr.main-ctr.club-modal-carrot .bottle-ctr svg');

    // let carrotCartMsg = document.querySelector('.carrot-ctr.carrot-cart .carrot-msg');
    // let carrotCartBtls = document.querySelectorAll('.carrot-ctr.carrot-cart .bottle-ctr img');

    if (qty <= 0) {
      carrotMainMsg.innerText = 'Uncork 1 cent shipping with 6 bottles'; //'ONE CENT shipping on any 6+ bottles!'
    } else if (qty <= 5) {
      if (qty == 5) {
        carrotMainMsg.innerText = `You’re ${6 - qty} bottle away from a shipping special!`;
      } else {
        carrotMainMsg.innerText = `You’re ${6 - qty} bottles away from a shipping special!`;
      }
    } else {
      carrotMainMsg.innerText = `You’ve uncorked special shipping rates!`;
    }

    [...carrotMainBtls].forEach((element, index, array) => {
      let bottle = element;
      let fill = bottle.querySelector('.bottle-trans');

      if (index + 1 <= qty) {
        if (!bottle.classList.contains('fill')) {
          fill.classList.add('fill');
        }
      } else {
        fill.classList.remove('fill');
      }
    });
  },
  init: function() {
    this.listenXHR();
    this.lookSession();
    this.clubReceiptCarrot();
    this.membershipDetailCarrot();
    this.clubCheckoutCarrot();
    this.clubProfileCarrot();
    this.clubModalCarrot();
  },
};

export default Carrot;
